import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import RestrictedSidebar, { kisitliTip } from './components/RestrictedSidebar';
// RealtimeModal is imported in Settings.js GlowyticsPixelSection
import './App.css';
import Overview from './pages/Overview';
import AdsOverview from './pages/ads-platforms/Overview';
import GoogleAds from './pages/ads-platforms/GoogleAds';
import UnifiedCampaigns from './pages/ads-platforms/UnifiedCampaigns';
import High5NetSalesUpload from './pages/high5/NetSalesUpload';
import MetaAds from './pages/ads-platforms/MetaAds';
import TikTokAds from './pages/ads-platforms/TikTokAds';
import Criteo from './pages/ads-platforms/Criteo';
import CriteoOverview from './pages/ads-platforms/CriteoOverview';
import AppleSearchAds from './pages/ads-platforms/AppleSearchAds';
import CanonCampaignReport from './pages/canon/CanonCampaignReport';
import CanonPlanVsActual from './pages/canon/CanonPlanVsActual';
import CanonMegatankReport from './pages/canon/CanonMegatankReport';
import CanonCeaReport from './pages/canon/CanonCeaReport';
import CanonLiveNameReport from './pages/canon/CanonLiveNameReport';
import CanonCoralReport from './pages/canon/CanonCoralReport';
import CanonCcmsMonthlyReport from './pages/canon/CanonCcmsMonthlyReport';
import MyAccount from './pages/MyAccount';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from 'react-hot-toast';
import BrandSelector from './pages/BrandSelector';
import { BrandProvider, BrandContext } from './context/BrandContext';
import { AccountProvider } from './context/AccountContext';
import GoogleAdsTest from './pages/ads-platforms/GoogleAdsTest';
import MetaAds2 from './pages/ads-platforms/MetaAds2';
import SourceMedium from './pages/analytics/SourceMedium';
import SourceMediumMonthly from './pages/analytics/SourceMediumMonthly';
import AdjustSourceMediumMonthly from './pages/analytics/AdjustSourceMediumMonthly';
import CombinedTrafficSources from './pages/analytics/CombinedTrafficSources';
import GoogleAdsOverview from './pages/ads-platforms/GoogleAdsOverview';
import DataSyncLogs from './pages/DataSyncLogs';
import AdjustTest from './pages/AdjustTest';
import AdjustAttributionCompare from './pages/AdjustAttributionCompare';
import ProductPerformance from './pages/analytics/ProductPerformance';
import CustomReports from './pages/custom-reports/CustomReports';
import KampanyaUrunSatis from './pages/analytics/KampanyaUrunSatis';
import Funnel from './pages/analytics/Funnel';
import Overview2 from './pages/Overview2';
import OverviewV16 from './pages/OverviewV16';
import OverviewV17 from './pages/OverviewV17';
import Overview5 from './pages/Overview5';
import OverviewV7 from './pages/OverviewV7';
import Overviewv21738 from './pages/Overviewv21738';
import Overviewv11 from './pages/Overviewv11';
import OverviewV9 from './pages/overviewV9';
import OverviewV10 from './pages/overviewV10';
import TestingOverview from './pages/TestingOverview';
import TestingOverview2 from './pages/TestingOverview2';
import CustomReport1 from './pages/custom-report/CustomReport1';
import CustomReport2 from './pages/custom-report/CustomReport2';
import CustomReport3 from './pages/custom-report/CustomReport3';
import CustomReport4 from './pages/custom-report/CustomReport4';
import CustomReport5 from './pages/custom-report/CustomReport5';
import CustomReport6 from './pages/custom-report/CustomReport6';
import CustomReport7 from './pages/custom-report/CustomReport7';
import BillingSpend from './pages/billing/BillingSpend';
import BillingSpendGeneral from './pages/billing/BillingSpendGeneral';
import HupalupaGroup from './pages/group/HupalupaGroup';
import HupalupaGroupBilling from './pages/group/HupalupaGroupBilling';
import HupalupaGroupBillingKopya from './pages/group/HupalupaGroupBillingKopya';
import ExecutiveWall from './pages/ExecutiveWall';
import AIChat from './pages/AIChat';

import XmlFeedAnalyzer from './pages/XmlFeedAnalyzer';
import TaskBoard from './pages/TaskBoard';
import QuickTaskTab from './components/TaskBoard/QuickTaskTab';
import HourlyPerformance from './pages/HourlyPerformance';
import SearchCampaigns from './pages/ads-platforms/google-ads/SearchCampaigns';
import SearchKeywordReport from './pages/ads-platforms/google-ads/SearchKeywordReport';
import SearchKeywordReportV3 from './pages/ads-platforms/google-ads/SearchKeywordReportV3';
import AdCopyReport from './pages/ads-platforms/google-ads/AdCopyReport';
import AdCopyReportYenilio from './pages/ads-platforms/google-ads/AdCopyReportYenilio';
import DisplayCampaigns from './pages/ads-platforms/google-ads/DisplayCampaigns';
import DemandGen from './pages/ads-platforms/google-ads/DemandGen';
import ShoppingCampaigns from './pages/ads-platforms/google-ads/ShoppingCampaigns';
import PerformanceMax from './pages/ads-platforms/google-ads/PerformanceMax';
import DynamicSearch from './pages/ads-platforms/google-ads/DynamicSearch';
import VideoCampaigns from './pages/ads-platforms/google-ads/VideoCampaigns';
import AppCampaigns from './pages/ads-platforms/google-ads/AppCampaigns';
import AudiencesTest from './pages/ads-platforms/google-ads/AudiencesTest';
import AudienceCreator from './pages/ads-platforms/google-ads/AudienceCreator';
import GoogleAdsAudienceInsights from './pages/ads-platforms/google-ads/GoogleAdsAudienceInsights';
import GdnCreatives from './pages/ads-platforms/google-ads/GdnCreatives';
import Forecasting from './pages/budget/Forecasting';
import RevenueForcasting from './pages/analytics/RevenueForcasting';
import FrontPage from './pages/FrontPage';
import MetaOverview from './pages/ads-platforms/MetaOverview';
import MetaCreativePerformance from './pages/ads-platforms/meta-ads/MetaCreativePerformance';
import MetaABCompare from './pages/ads-platforms/meta-ads/MetaABCompare';
import MetaRmVsNewUser from './pages/ads-platforms/meta-ads/MetaRmVsNewUser';
import PinterestCreativePerformance from './pages/ads-platforms/pinterest/PinterestCreativePerformance';
import TikTokCreativePerformance from './pages/ads-platforms/tiktok-ads/TikTokCreativePerformance';
import GoogleCreativePerformance from './pages/ads-platforms/google-ads/GoogleCreativePerformance';
import PMaxAssetPerformance from './pages/ads-platforms/google-ads/PMaxAssetPerformance';
import SearchVisibility from './pages/ads-platforms/google-ads/SearchVisibility';
import ImpressionShareMatrix from './pages/ads-platforms/google-ads/ImpressionShareMatrix';
import WhyGlowytics from './pages/WhyGlowytics';
import MetaTodayImpressions from './pages/ads-platforms/meta-ads/MetaTodayImpressions';
import MetaCampaignType from './pages/ads-platforms/meta-ads/campaign-type';
import MetaEngagementMonitor from './pages/ads-platforms/meta-ads/EngagementMonitor';
import TikTokCampaignType from './pages/ads-platforms/tiktok-ads/campaign-type';
import MonthlyTargetsDashboard from './pages/MonthlyTargetsDashboard';
import MetaAudiences from './pages/ads-platforms/meta-ads/MetaAudiences';
import MetaAudienceInsights from './pages/ads-platforms/meta-ads/MetaAudienceInsights';
import MetaCreativeTest from './pages/experiments/MetaCreativeTest';
import TiktokAdsTest from './pages/experiments/TiktokAdsTest';
import AppleSearchAdsTest from './pages/experiments/AppleSearchAdsTest';
import AnalyticsOverview from './pages/analytics/AnalyticsOverview';
import GA4Overview from './pages/analytics/GA4Overview';
import GA4CustomDimensions from './pages/analytics/GA4CustomDimensions';
import GA4Audience from './pages/analytics/GA4Audience';
import DailyTraffic from './pages/analytics/DailyTraffic';
import PageSourceMediumLive from './pages/analytics/PageSourceMediumLive';
import NewVsReturningRevenue from './pages/analytics/NewVsReturningRevenue';
import AdjustOverview from './pages/analytics/adjust-overview';
import AdjustTraffic from './pages/analytics/AdjustTraffic';
import MarketShareDashboard from './pages/competitors/MarketShare';
import ShareOfVoiceDashboard from './pages/competitors/ShareOfVoice';
import ProductPortfolioAnalysis from './pages/analytics/ProductPortfolioAnalysis';
import ProductPortfolioAnalysis2 from './pages/analytics/ProductPortfolioAnalysis2';
import PriceElasticityOfDemand from './pages/analytics/PriceElasticityOfDemand';
import ChannelMixReallocationDemo from './pages/analytics/ChannelMixReallocationDemo';
import SeasonalityForecastDemo from './pages/analytics/SeasonalityForecastDemo';
import RfmLifecycleDemo from './pages/analytics/RfmLifecycleDemo';
import RetentionDriversDemo from './pages/analytics/RetentionDriversDemo';
import AudienceSegmentationDemo from './pages/analytics/AudienceSegmentationDemo';
import MMMDemo from './pages/analytics/MMMDemo';
import PeriodAnalysis from './pages/analytics/PeriodAnalysis'; // Dönemsel Analiz Sayfası
import InternalSearchTerms from './pages/analytics/InternalSearchTerms';
import BrandingForecast from './pages/budget/BrandingForecast';
import MediaPlanningTable from './pages/budget/MediaPlanningTable';
import MediaPlanTable from './pages/budget/MediaPlanTable';
import SimpleBrandingForecast from './pages/budget/SimpleBrandingForecast';
import BrandingForecastSWOT3453534 from './pages/budget/BrandingForecastSWOT3453534';
import BrandingForecast43058209 from './pages/budget/BrandingForecast43058209';
import HupalupaNisan2026 from './pages/budget/HupalupaNisan2026';
import HupalupaMayis2026 from './pages/budget/HupalupaMayis2026';
import HupalupaHaziran2026, { HupalupaStoreHaziran2026, HupalupaEglenceHaziran2026 } from './pages/budget/HupalupaHaziran2026';
import HupalupaAgustos2026, { HupalupaStoreAgustos2026, HupalupaEglenceAgustos2026 } from './pages/budget/HupalupaAgustos2026';
import KixxAgustos2026 from './pages/budget/KixxAgustos2026';
import KerametIlicasiAgustos2026 from './pages/budget/KerametIlicasiAgustos2026';
import HupalupaStoreEylul2026 from './pages/budget/HupalupaStoreEylul2026';
import HupalupaStoreEylul2026MedyaPlani from './pages/budget/HupalupaStoreEylul2026MedyaPlani';
import HupalupaStoreEylul2026MarkaButcesi from './pages/budget/HupalupaStoreEylul2026MarkaButcesi';
import HupalupaStoreEkim2026MarkaButcesi from './pages/budget/HupalupaStoreEkim2026MarkaButcesi';
import HupalupaEglenceEylul2026 from './pages/budget/HupalupaEglenceEylul2026';
import KixxEylul2026 from './pages/budget/KixxEylul2026';
import KixxEylul2026MedyaPlani from './pages/budget/KixxEylul2026MedyaPlani';
import HupalupaEglenceEylul2026MedyaPlani from './pages/budget/HupalupaEglenceEylul2026MedyaPlani';
import KerametIlicasiEylul2026MedyaPlani from './pages/budget/KerametIlicasiEylul2026MedyaPlani';
import KerametIlicasiEylul2026 from './pages/budget/KerametIlicasiEylul2026';
import HupalupaEylulDurum from './pages/budget/HupalupaEylulDurum';
import HunterEylul2026MedyaPlani from './pages/budget/HunterEylul2026MedyaPlani';
import SalomonWunderEylulKasim2026 from './pages/budget/SalomonWunderEylulKasim2026';
import BirkenstockWunderEkimAralik2026 from './pages/budget/BirkenstockWunderEkimAralik2026';
import MediaPlanStudio from './pages/budget/MediaPlanStudio';
import InstagramStudio from './pages/social/InstagramStudio';
import MarkaTalepleri from './pages/MarkaTalepleri';
import KullaniciTakip from './pages/KullaniciTakip';
import Kumbara from './pages/Kumbara';
import LinkedInStudyo from './pages/LinkedInStudyo';
import { YeniKullanicilar, YeniMarkalar } from './pages/YeniKayitlar';
import HealthCheck from './pages/HealthCheck';
import KixxHaziran2026 from './pages/budget/KixxHaziran2026';
import HupalupaGoKalamisFestival from './pages/budget/HupalupaGoKalamisFestival';
import HupalupaGoReport from './pages/budget/HupalupaGoReport';
import HupalupaGoPresentation from './pages/budget/HupalupaGoPresentation';
import HupalupaBrandStock from './pages/reports/HupalupaBrandStock';
import HupalupaLokasyonReport from './pages/HupalupaLokasyonReport';
import HupalupaZooFamilyRaporu from './pages/HupalupaZooFamilyRaporu';
import HupalupaZooFamilyReportEn from './pages/HupalupaZooFamilyReportEn';
import HupalupaKanalSatis from './pages/HupalupaKanalSatis';
import DivanevLokasyonReport from './pages/DivanevLokasyonReport';
import YatasBeddingGeoReport from './pages/YatasBeddingGeoReport';
import OnFw26Rehber from './pages/OnFw26Rehber';
import High5RmDagilimi from './pages/High5RmDagilimi';
import High5KaynakBuyume from './pages/High5KaynakBuyume';
import High5KanalHunisi from './pages/High5KanalHunisi';
import High5MobilDonusum from './pages/High5MobilDonusum';
import High5MobilOzet from './pages/High5MobilOzet';
import High5OnGoogleAds from './pages/High5OnGoogleAds';
import High5MetaAds from './pages/High5MetaAds';
import TemizmamaHazirlik from './pages/TemizmamaHazirlik';
import PlaymobilStrateji from './pages/budget/PlaymobilStrateji';
import LearningResourcesTalep from './pages/budget/LearningResourcesTalep';
import HupalupaQ4_2026 from './pages/budget/HupalupaQ4_2026';
import HupalupaPerformans2026 from './pages/budget/HupalupaPerformans2026';
import PlaymobilHupalupa2026 from './pages/budget/PlaymobilHupalupa2026';
import HupalupaKasimAralik2026 from './pages/budget/HupalupaKasimAralik2026';
import CrayolaTalep from './pages/budget/CrayolaTalep';
import PlaymobilViral from './pages/budget/PlaymobilViral';
import FitnessSeasonality from './pages/budget/FitnessSeasonality';
import CanonApril2026 from './pages/budget/CanonApril2026';
import CanonBeyondFrame2026 from './pages/budget/CanonBeyondFrame2026';
import CanonJuly2026 from './pages/budget/CanonJuly2026';
import CanonBackToSchool2026 from './pages/budget/CanonBackToSchool2026';
import EuropcarProgramatik2026 from './pages/budget/EuropcarProgramatik2026';
import CanonCorals2026 from './pages/budget/CanonCorals2026';
import CanonCoralsMonthly from './pages/budget/CanonCoralsMonthly';
import CanonCoralsAll from './pages/budget/CanonCoralsAll';
import KixzSeo2026 from './pages/budget/KixzSeo2026';
import CanonCCMSContentPlan from './pages/budget/CanonCCMSContentPlan';
import CanonCCMSContentPlanJuly from './pages/budget/CanonCCMSContentPlanJuly';
import CanonCCMSContentPlanAugust from './pages/budget/CanonCCMSContentPlanAugust';
import CanonCCMSContentPlanSeptember from './pages/budget/CanonCCMSContentPlanSeptember';
import CanonPVEylul2026 from './pages/budget/CanonPVEylul2026';
import CanonLensTradeIn2026 from './pages/budget/CanonLensTradeIn2026';
import CanonBeyondFrameContent from './pages/budget/CanonBeyondFrameContent';
import High5Haziran2026 from './pages/budget/High5Haziran2026';
import High5CrossMarketing from './pages/analytics/High5CrossMarketing';
import BrandingForecastYenilio from './pages/budget/BrandingForecastYenilio';
import BrandingPlanJakamen from './pages/budget/BrandingPlanJakamen';
import BrandingPlanJakamen250K from './pages/budget/BrandingPlanJakamen250K';
import BrandingPlanJakamenWorldCup from './pages/budget/BrandingPlanJakamenWorldCup';
import BrandingPlanHigh5 from './pages/budget/BrandingPlanHigh5';
import High5CampaignMonthlyLive from './pages/budget/High5CampaignMonthlyLive';
import BrandingPlanRegalien from './pages/budget/BrandingPlanRegalien';
import GurgencilerQ12026 from './pages/budget/GurgencilerQ12026';
import GurgencilerDunyaKupasi2026 from './pages/budget/GurgencilerDunyaKupasi2026';
import MarketingReports from './pages/budget/MarketingReports';
import PaymentCallback from './pages/PaymentCallback';
import CreativeBuilder from './pages/CreativeBuilder';
import AdsBuilder from './pages/AdsBuilder';
import MomentumBuilder from './pages/MomentumBuilder';
import BigQueryExplorer from './pages/BigQueryExplorer';
import BQAnalyticsDashboard from './pages/BQAnalyticsDashboard';
import BQTrafficSourcesDaily from './pages/analytics/BQTrafficSourcesDaily';
import MetaBilling from './pages/MetaBilling';
import BQItemSalesReport from './pages/BQItemSalesReport';
import SixtStoreBranchPerformance from './pages/SixtStoreBranchPerformance';
import High5FunnelPerformance from './pages/high5/FunnelPerformance';
import SixtLocationPricing from './pages/SixtLocationPricing';
import SixtVehiclePerformance from './pages/SixtVehiclePerformance';
import ChatbotV2 from './pages/ChatbotV2';
import Glowyaigamini from './pages/Glowyaigamini';
import AdminPanel from './pages/AdminPanel';
import AdminSmartCampaigns from './pages/AdminSmartCampaigns';
import AdminMcDisapprovalMonitor from './pages/AdminMcDisapprovalMonitor';
import AdminGoogleAdsClone from './pages/AdminGoogleAdsClone';
import ProjectBacklog from './pages/ProjectBacklog';
import GbpHq from './pages/GbpHq';
import GbpLocations from './pages/GbpLocations';
import WebSummitBrief from './pages/WebSummitBrief';
import NarrativeFlow from './pages/NarrativeFlow';
import SmartCampaignDetail from './pages/SmartCampaignDetail';
import PixelAnalytics from './pages/PixelAnalytics';
import AdsLibrary from './pages/competitors/AdsLibrary';
import SearchVolume from './pages/competitors/SearchVolume';
import SearchVolumeDigest from './pages/internal/SearchVolumeDigest';
import SearchVolumeMatrix from './pages/market-insights/SearchVolumeMatrix';
import High5SearchResearch from './pages/market-insights/High5SearchResearch';
import AdShelfShare from './pages/market-insights/AdShelfShare';
import GoogleTrends from './pages/competitors/GoogleTrends';
import YouTubeTrends from './pages/competitors/YouTubeTrends';
import YouTubePopularity from './pages/market-insights/YouTubePopularity';
import YouTubeAIResearch from './pages/market-insights/YouTubeAIResearch';
import RtbHouseConnect from './pages/market-insights/RtbHouseConnect';
import PinterestTest from './pages/market-insights/PinterestTest';
import PinterestDashboard from './pages/market-insights/PinterestDashboard';
import YouTubeCampaignsLab from './pages/experiments/YouTubeCampaignsLab';
import KeywordDiscover from './pages/market-insights/KeywordDiscover';
import CategorySeasonality from './pages/competitors/CategorySeasonality';
import CampaignCalendar from './pages/competitors/CampaignCalendar';
import AdsTransparencyTest from './pages/experiments/AdsTransparencyTest';
import MetaAdLibraryLab from './pages/experiments/MetaAdLibraryLab';
import GoogleAdsCampaignsLab from './pages/experiments/GoogleAdsCampaignsLab';
import MetaAdsCampaignsLab from './pages/experiments/MetaAdsCampaignsLab';
import MetaCatalogAdsLab from './pages/experiments/MetaCatalogAdsLab';
import MetaMediaLibraryLab from './pages/experiments/MetaMediaLibraryLab';
import BannerClickHeatmap from './pages/experiments/BannerClickHeatmap';
import MetaAIEnhancerLab from './pages/experiments/MetaAIEnhancerLab';
import MerchantAIStudioLab from './pages/experiments/MerchantAIStudioLab';
import MetaImageCampaignLab from './pages/experiments/MetaImageCampaignLab';
import MetaInstagramDebug from './pages/experiments/MetaInstagramDebug';
import MetaPagesLab from './pages/experiments/MetaPagesLab';
import GoogleTrendsTest from './pages/experiments/GoogleTrendsTest';
import GoogleTrendsCategoryTest from './pages/experiments/GoogleTrendsCategoryTest';
import MetaCatalogTest from './pages/experiments/MetaCatalogTest';
import MetaCatalogProducts from './pages/experiments/MetaCatalogProducts';
import KeywordPlannerTest from './pages/experiments/KeywordPlannerTest';
import MerchantCenterTest from './pages/experiments/MerchantCenterTest';
import LiveToday from './pages/experiments/LiveToday';
import InfluencerProbe from './pages/experiments/InfluencerProbe';
import SearchConsoleLab from './pages/experiments/SearchConsoleLab';
import IkasApiLab from './pages/experiments/IkasApiLab';
import IkasOrdersViewer from './pages/experiments/IkasOrdersViewer';
import ShopifyLab from './pages/experiments/ShopifyLab';
import SendgridTest from './pages/experiments/SendgridTest';
import GBPTest from './pages/experiments/GBPTest';
import WooCommerceLab from './pages/experiments/WooCommerceLab';
import TsoftSalesLab from './pages/experiments/TsoftSalesLab';
import SiteMetaCrawlerLab from './pages/experiments/SiteMetaCrawlerLab';
import MetaAudiencesLab from './pages/experiments/MetaAudiencesLab';
import SearchVolumeBulk from './pages/experiments/SearchVolumeBulk';
import KeywordDiscoverBulk from './pages/experiments/KeywordDiscoverBulk';
import SearchCampaignWizard from './pages/experiments/SearchCampaignWizard';
import InstagramRadar from './pages/experiments/InstagramRadar';
import InstagramComments from './pages/experiments/InstagramComments';
import InstagramSearchLab from './pages/experiments/InstagramSearchLab';
import High5KeywordResearch from './pages/experiments/High5KeywordResearch';
import TiktokRadarLab from './pages/experiments/TiktokRadarLab';
import AppRadar from './pages/market-insights/AppRadar';
import MultipayReviewAnalysis from './pages/market-insights/MultipayReviewAnalysis';
import FacebookAdsLibraryRapidLab from './pages/experiments/FacebookAdsLibraryRapidLab';
import GoogleAdsTransparencyRapidLab from './pages/experiments/GoogleAdsTransparencyRapidLab';
import MerchantCenterPerformance from './pages/merchant/MerchantCenterPerformance';
import MerchantCenterPriceBenchmark from './pages/merchant/MerchantCenterPriceBenchmark';
import MerchantCenterInventory from './pages/merchant/MerchantCenterInventory';
import MerchantCenterInventoryPerformance from './pages/merchant/MerchantCenterInventoryPerformance';
import MerchantInsights from './pages/market-insights/MerchantInsights';
import MerchantInsights2 from './pages/market-insights/MerchantInsights2';
import MerchantPriceInsights2 from './pages/market-insights/MerchantPriceInsights2';
import MerchantCenterVariantPerformance from './pages/merchant/MerchantCenterVariantPerformance';
import MerchantCenterCustomLabels from './pages/merchant/MerchantCenterCustomLabels';
import MerchantCenterDiscountTracker from './pages/merchant/MerchantCenterDiscountTracker';
import KediKopekBurc from './pages/KediKopekBurc';
import SearchConsoleOverview from './pages/search-console/SearchConsoleOverview';
import MonthlyQueries from './pages/search-console/MonthlyQueries';
import BlogSeo from './pages/search-console/BlogSeo';
import GeminiPlayground from './pages/GeminiPlayground';
import DeepResearchPlayground from './pages/DeepResearchPlayground';
import MapsGroundingPlayground from './pages/MapsGroundingPlayground';
import PlaceReviews from './pages/PlaceReviews';
import IkasOverview from './pages/ikas/IkasOverview';
import ShopifyOverview from './pages/shopify/ShopifyOverview';
import ShopifyProductPerformance from './pages/shopify/ShopifyProductPerformance';
import ShopifyCustomerSegments from './pages/shopify/ShopifyCustomerSegments';
import ShopifyCustomerPurchaseSegments from './pages/shopify/ShopifyCustomerPurchaseSegments';
import ShopifyCustomerCategorySegments from './pages/shopify/ShopifyCustomerCategorySegments';
import ShopifyProductCustomerSegments from './pages/shopify/ShopifyProductCustomerSegments';
import ShopifyLoyalty from './pages/shopify/ShopifyLoyalty';
import IkasProductPerformance from './pages/ikas/IkasProductPerformance';
import IkasCustomSegments from './pages/ikas/IkasCustomSegments';
import IkasBuyingSegment from './pages/ikas/IkasBuyingSegment';
import IkasCustomerCategorySegments from './pages/ikas/IkasCustomerCategorySegments';
import IkasProductCustomerSegments from './pages/ikas/IkasProductCustomerSegments';
import IkasLoyalty from './pages/ikas/IkasLoyalty';
import IkasSandbox from './pages/ikas/IkasSandbox';
import IkasStockByBrand from './pages/ikas/IkasStockByBrand';
import IkasInventory from './pages/ikas/IkasInventory';
import IkasStockCoverage from './pages/ikas/IkasStockCoverage';
import IkasMonthlyFetch from './pages/ikas/IkasMonthlyFetch';
import WooOverview from './pages/woocommerce/WooOverview';
import WooProductPerformance from './pages/woocommerce/WooProductPerformance';
import WooCustomSegments from './pages/woocommerce/WooCustomSegments';
import WooBuyingSegment from './pages/woocommerce/WooBuyingSegment';
import WooCustomerCategorySegments from './pages/woocommerce/WooCustomerCategorySegments';
import WooProductCustomerSegments from './pages/woocommerce/WooProductCustomerSegments';
import WooLoyalty from './pages/woocommerce/WooLoyalty';
import LiveSnippet from './pages/LiveSnippet';
import PoCShowcase from './pages/PoCShowcase';
import IkasConnect from './pages/IkasConnect';
import ShopifyConnect from './pages/ShopifyConnect';
import CampaignReport from './pages/reports/CampaignReport';
import SalomonCampaignReport from './pages/reports/SalomonCampaignReport';
import AdidasCampaignReport from './pages/reports/AdidasCampaignReport';
import AsicsCampaignReport from './pages/reports/AsicsCampaignReport';
import WunderPlanTakip from './pages/reports/WunderPlanTakip';
import CampaignThemes from './pages/reports/CampaignThemes';
import AudienceSuggestions from './pages/ads-platforms/meta-ads/AudienceSuggestions';
import MetaGoSpendReport from './pages/reports/MetaGoSpendReport';
import YenilioStrategyPlan from './pages/YenilioStrategyPlan';
import GurgenclerCXReport from './pages/GurgenclerCXReport';
import GurgenclerReport from './pages/GurgenclerReport';
import GurgenclerBTS2026 from './pages/GurgenclerBTS2026';
import GurgenclerLansman2026 from './pages/GurgenclerLansman2026';
import GurgenclerIletisim2026 from './pages/GurgenclerIletisim2026';
import GurgenclerFikirler from './pages/GurgenclerFikirler';
import EuropcarSeoRaporu from './pages/EuropcarSeoRaporu';
import EuropcarCalismaOzeti from './pages/EuropcarCalismaOzeti';
import EuropcarGecisDegerlendirme from './pages/EuropcarGecisDegerlendirme';
import ClubSporiumTeklif from './pages/ClubSporiumTeklif';
import CommonLeisureDenetim from './pages/CommonLeisureDenetim';
import YorstrulyDenetim from './pages/YorstrulyDenetim';
import UnderArmour2027 from './pages/UnderArmour2027';
import MultinetTanisma from './pages/MultinetTanisma';
import BaqaSeo from './pages/BaqaSeo';
import YatasGeoSunum from './pages/YatasGeoSunum';
import TrioMobilDenetim from './pages/TrioMobilDenetim';
import TrioMobilOzet from './pages/TrioMobilOzet';
import CoffrasWeb from './pages/CoffrasWeb';
import CoffrasPrototip from './pages/CoffrasPrototip';
import RegalienOzet from './pages/RegalienOzet';
import TemizmamaSunum from './pages/TemizmamaSunum';
import TemizmamaYonetim from './pages/TemizmamaYonetim';
import TemizmamaBranding from './pages/TemizmamaBranding';
import JujuGorselKiyas from './pages/JujuGorselKiyas';
import High5On from './pages/High5On';
import High5OnEtki from './pages/High5OnEtki';
import High5AsicsIndirim from './pages/High5AsicsIndirim';
import High5OnHaftalik from './pages/High5OnHaftalik';
import High5Ekim from './pages/High5Ekim';
import YorstrulyKasim from './pages/YorstrulyKasim';
import High5OnCalismaIlkeleri from './pages/High5OnCalismaIlkeleri';
import NnormalArama from './pages/NnormalArama';
import CommonLeisureVideo from './pages/CommonLeisureVideo';
import CommonLeisureTeklif from './pages/CommonLeisureTeklif';
import YorstrulyTeklif from './pages/YorstrulyTeklif';
import OzelNot from './pages/OzelNot';
import CerceveAtolyesi from './pages/CerceveAtolyesi';
import GlowyStudioTeklif from './pages/GlowyStudioTeklif';
import IdefixStudioTeklif from './pages/IdefixStudioTeklif';
import IdefixUspoloCerceve from './pages/IdefixUspoloCerceve';
import WidgetStudio from './pages/WidgetStudio';
import AttributionTracking from './pages/AttributionTracking';
import AttributionData from './pages/AttributionData';
import AttributionSetup from './pages/AttributionSetup';
import ChatAssistantStudio from './pages/ChatAssistantStudio';
import EmailPlatform from './pages/EmailPlatform';
import LeadInbox from './pages/LeadInbox';
import IdefixUretim from './pages/IdefixUretim';
import AsicsGorunurluk from './pages/AsicsGorunurluk';
import GurgenclerRawData from './pages/GurgenclerRawData';
import EuropcarMeetingNotes from './pages/EuropcarMeetingNotes';
import EuropcarBlogReport from './pages/EuropcarBlogReport';
import ContentStudio from './pages/content/ContentStudio';
import EuropcarNonBrandReport from './pages/EuropcarNonBrandReport';
import EuropcarLocationPages from './pages/EuropcarLocationPages';
import EuropcarGa4Panel from './pages/EuropcarGa4Panel';
import EuropcarKaynakRaporu from './pages/EuropcarKaynakRaporu';
import GoogleAdsDonusumKirilimi from './pages/GoogleAdsDonusumKirilimi';
import EuropcarDataLayerSpec from './pages/EuropcarDataLayerSpec';
import EuropcarCheckoutAudit from './pages/EuropcarCheckoutAudit';
import EuropcarAramaTalebi from './pages/EuropcarAramaTalebi';
import EuropcarGoogleIsimReport from './pages/EuropcarGoogleIsimReport';
import EuropcarLoginReport from './pages/EuropcarLoginReport';
import EuropcarGooglePuan from './pages/EuropcarGooglePuan';
import SiteFlowMap from './pages/SiteFlowMap';
import MimicCaseReport from './pages/MimicCaseReport';
import OnTurkiyeDeck from './pages/OnTurkiyeDeck';
import KlaudOutletDeck from './pages/KlaudOutletDeck';
import TemizmamaTeklifDeck from './pages/TemizmamaTeklifDeck';
import GlowyaiSunum from './pages/GlowyaiSunum';
import CoffrasAklTeklifDeck from './pages/CoffrasAklTeklifDeck';
import SkechersGlowyticsOffer from './pages/SkechersGlowyticsOffer';
import GrupGlowyticsOffer from './pages/GrupGlowyticsOffer';
import UcMarkaGlowyticsOffer from './pages/UcMarkaGlowyticsOffer';
import OnGlowyticsOffer from './pages/OnGlowyticsOffer';
import KixxYoutubeReport from './pages/KixxYoutubeReport';
import High5NetSalesPublic from './pages/public/High5NetSalesPublic';
import High5MobilDonusumPublic from './pages/public/High5MobilDonusumPublic';
import WunderBirkenstockPublic from './pages/public/WunderBirkenstockPublic';
import { HIGH5_NET_SALES_PATH, HIGH5_MOBIL_DONUSUM_PATH, WUNDER_BIRKENSTOCK_PATH, YATAS_AI_VISIBILITY_PATH } from './config/publicReportLinks';
import YatasAiVisibilityPublic from './pages/public/YatasAiVisibilityPublic';
import HupalupaYoutubeReport from './pages/HupalupaYoutubeReport';
import HupalupaAnasayfaAkis from './pages/HupalupaAnasayfaAkis';
import AnasayfaKategoriAkisi from './pages/AnasayfaKategoriAkisi';
import FaviconSerpReport from './pages/FaviconSerpReport';
import YatasSapVeri from './pages/YatasSapVeri';
import PinterestFormatlari from './pages/PinterestFormatlari';
import PinterestAds from './pages/PinterestAds';
import WunderBirkenstockEngagement from './pages/WunderBirkenstockEngagement';
import ImageEditor from './pages/ImageEditor';
import ImageEnhance from './pages/ImageEnhance';
import ImageEqualize from './pages/ImageEqualize';
import PngBackgroundFitter from './pages/PngBackgroundFitter';
import PlatformResizer from './pages/PlatformResizer';
import PastPerfectStudio from './pages/PastPerfectStudio';
import ProductConcept from './pages/ProductConcept';
import JoyicoStudio from './pages/JoyicoStudio';
import InviterAds from './pages/InviterAds';
import BqChannelPerformanceTest from './pages/BqChannelPerformanceTest';
import MegapixelFit from './pages/MegapixelFit';
import AdsLibraryExport from './pages/AdsLibraryExport';
import MetaStaticAssets from './pages/MetaStaticAssets';
import BudgetOverview from './pages/BudgetOverview';
import SessionEngagement from './pages/analytics/SessionEngagement';
import HourlyOrderAnalysis from './pages/analytics/HourlyOrderAnalysis';
import DailyFunnel from './pages/analytics/DailyFunnel';
import WeekdayOrderAnalysis from './pages/analytics/WeekdayOrderAnalysis';
import High5SkuSizeCoverage from './pages/analytics/High5SkuSizeCoverage';
import High5Ltv from './pages/analytics/High5Ltv';
import High5FeedCompare from './pages/high5/FeedCompare';
import High5DailyTargetTracking from './pages/high5/DailyTargetTracking';
import High5BrandSearchCoverage from './pages/high5/BrandSearchCoverage';
import High5AuctionInsights from './pages/high5/AuctionInsights';
import High5WeeklyKpi from './pages/high5/WeeklyKpi';
import High5MtdTarget from './pages/high5/MtdTarget';
import High5WeeklyMail from './pages/high5/WeeklyMail';
import CreativeInsights from './pages/CreativeInsights';
import BrandLiveTracker from './pages/BrandLiveTracker';
import BlackspadeConversionAudit from './pages/blackspade/ConversionAudit';
import High5McSizeAccumulation from './pages/analytics/High5McSizeAccumulation';
import High5ProductRevenueStock from './pages/analytics/High5ProductRevenueStock';
import High5SizeBreakageWeekly from './pages/analytics/High5SizeBreakageWeekly';
import High5TopSellerSizeStatus from './pages/analytics/High5TopSellerSizeStatus';
import High5ProductSalesPeriods from './pages/analytics/High5ProductSalesPeriods';
import High5Yesterday from './pages/analytics/High5Yesterday';
import High5PriceCompetitivenessDaily from './pages/analytics/High5PriceCompetitivenessDaily';
import KotonGa4Business from './pages/koton/KotonGa4Business';
import GraceCatalog from './pages/grace/GraceCatalog';
import PaulmarkCatalog from './pages/paulmark/PaulmarkCatalog';
import WeeklyExecutiveReport from './pages/WeeklyExecutiveReport';
import Pacing from './pages/Pacing';
import Portfolio from './pages/Portfolio';
import AdsChangeHistory from './pages/AdsChangeHistory';
import MetaAdInspector from './pages/MetaAdInspector';
import MetaCarouselCards from './pages/MetaCarouselCards';
import InsightsFeed from './pages/InsightsFeed';
import SahlanmaCommandCenter from './pages/SahlanmaCommandCenter';
import YatasKpiTargets from './pages/YatasKpiTargets';
import MonthlyBulletin from './pages/yatas/MonthlyBulletin';
import DynamicTracking from './pages/yatas/DynamicTracking';
import CampaignCodes from './pages/yatas/CampaignCodes';
import PerformancePanel from './pages/yatas/PerformancePanel';
import YatasPlanning from './pages/YatasPlanning';
import YatasDavranisSegmentasyonu from './pages/YatasDavranisSegmentasyonu';
import YatasDavranisHaritasi from './pages/YatasDavranisHaritasi';
import YatasLocalPerformance from './pages/YatasLocalPerformance';
import YatasAlertsPrototype from './pages/YatasAlertsPrototype';
import YatasAiVisibility from './pages/YatasAiVisibility';
import AiVisibilitySources from './pages/AiVisibilitySources';
import AiVisibilityTodo from './pages/AiVisibilityTodo';
import AiVisibilityPersonas from './pages/AiVisibilityPersonas';
import YatasFrameStudio from './pages/YatasFrameStudio';
import FeedBuilder from './pages/FeedBuilder';
import DigitalMarketing101 from './pages/DigitalMarketing101';
import ConsentModeV2 from './pages/ConsentModeV2';
import CompetitorOnComparison from './pages/CompetitorOnComparison';
import High5SellerPriceMatrix from './pages/High5SellerPriceMatrix';
import PropiaPriceTracking from './pages/PropiaPriceTracking';
import PriceBenchmarkVsComparison from './pages/PriceBenchmarkVsComparison';
import PlaymobilCatalog from './pages/PlaymobilCatalog';
import WunderCostPerSale from './pages/WunderCostPerSale';
import MetaProductSpend from './pages/ads-platforms/meta-ads/MetaProductSpend';
import AppOverview from './pages/AppOverview';

// Expose YouTube API key from .env to window for client-only pages
if (typeof window !== 'undefined') {
  const YT_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || process.env.YOUTUBE_API_KEY;
  if (YT_KEY) {
    window.__YOUTUBE_API_KEY__ = YT_KEY;
  }
  // Swallow AbortError overlays caused by navigation aborts
  if (!window.__abortHandlerInstalled__) {
    // Benign, non-actionable errors that should NOT trigger the dev error overlay:
    // navigation aborts, and transient network failures (machine sleeps / Wi-Fi
    // drops while idle, or a browser extension breaks fetch with "Failed to fetch").
    // Handled fetches (e.g. a page showing its own error state) never reach these
    // global handlers — only truly unhandled rejections do.
    const isBenignError = (e) => {
      const name = e?.name || '';
      const msg = e?.message || String(e || '');
      return (
        name === 'AbortError' ||
        msg.includes('AbortError') ||
        msg.includes('signal is aborted') ||
        msg.includes('Failed to fetch') ||
        msg.includes('NetworkError') ||
        msg.includes('Load failed')
      );
    };
    // 1) Global unhandledrejection guard
    window.addEventListener('unhandledrejection', (event) => {
      try {
        if (isBenignError(event?.reason)) {
          event.preventDefault();
        }
      } catch (_) {}
    });
    // 2) Global error guard (some libs throw AbortError as Error)
    window.addEventListener('error', (event) => {
      try {
        if (isBenignError(event?.error)) {
          event.preventDefault();
        }
      } catch (_) {}
    }, true);
    // 3) Safe fetch wrapper: convert AbortError to 499 response, and fall back to
    //    XHR when browser extensions break fetch with "Failed to fetch" TypeErrors.
    try {
      // Try to recover the browser's native fetch from a hidden iframe — this
      // bypasses extension monkey-patches that hook window.fetch. Keep the
      // iframe attached so the contentWindow stays alive.
      let nativeFetch = null;
      try {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText = 'display:none !important;width:0;height:0;border:0;';
        iframe.src = 'about:blank';
        (document.body || document.documentElement).appendChild(iframe);
        const cw = iframe.contentWindow;
        if (cw && typeof cw.fetch === 'function') {
          const bound = cw.fetch.bind(cw);
          nativeFetch = (input, init) => bound(input, init);
          window.__glowyNativeFetchIframe__ = iframe;
        }
      } catch (_) {}
      const originalFetch = nativeFetch || window.fetch;

      function xhrFallback(input, init = {}) {
        return new Promise((resolve, reject) => {
          try {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            const method = (init.method || 'GET').toUpperCase();
            const xhr = new XMLHttpRequest();
            xhr.open(method, url, true);
            if (init.credentials === 'include') xhr.withCredentials = true;
            const headers = init.headers || {};
            if (headers instanceof Headers) {
              headers.forEach((v, k) => xhr.setRequestHeader(k, v));
            } else if (Array.isArray(headers)) {
              headers.forEach(([k, v]) => xhr.setRequestHeader(k, v));
            } else if (typeof headers === 'object') {
              Object.keys(headers).forEach((k) => xhr.setRequestHeader(k, headers[k]));
            }
            xhr.onload = () => {
              try {
                const body = xhr.responseText;
                const res = new Response(body, { status: xhr.status, statusText: xhr.statusText });
                resolve(res);
              } catch {
                resolve({
                  ok: xhr.status >= 200 && xhr.status < 300,
                  status: xhr.status,
                  statusText: xhr.statusText,
                  text: async () => xhr.responseText,
                  json: async () => JSON.parse(xhr.responseText || 'null'),
                });
              }
            };
            xhr.onerror = () => reject(new TypeError('XHR fallback failed'));
            xhr.ontimeout = () => reject(new TypeError('XHR fallback timeout'));
            xhr.send(init.body || null);
          } catch (err) {
            reject(err);
          }
        });
      }

      window.fetch = async (...args) => {
        try {
          return await originalFetch(...args);
        } catch (e) {
          const name = e?.name || '';
          const msg = e?.message || String(e || '');
          if (name === 'AbortError' || msg.includes('AbortError') || msg.includes('signal is aborted')) {
            try {
              return new Response(null, { status: 499, statusText: 'ClientClosed(Abort)' });
            } catch {
              return { ok: false, status: 499, statusText: 'ClientClosed(Abort)' };
            }
          }
          // Fall back to XHR when fetch is broken by a browser extension hook.
          if (name === 'TypeError' || msg.includes('Failed to fetch') || msg.includes('NetworkError')) {
            try {
              return await xhrFallback(args[0], args[1]);
            } catch (_) {
              throw e;
            }
          }
          throw e;
        }
      };
    } catch (_) {}
    window.__abortHandlerInstalled__ = true;
  }
}


// Geçici sayfa bileşenleri
const PageTemplate = ({ title }) => (
  <div className="page-content">
    <h1>{title}</h1>
  </div>
);

// TaskBoardWrapper Component
const TaskBoardWrapper = () => {
  const { brandId: brandIdFromUrl } = useParams();
  const brandContext = useContext(BrandContext);
  
  // brandContext veya selectedBrand null/undefined olabilir, kontrol edelim
  const selectedBrand = brandContext ? brandContext.selectedBrand : null;

  // selectedBrand.id yerine backend'den gelen brand objesindeki id alanı neyse o kullanılmalı.
  // Genellikle bu sadece `selectedBrand.id` olur.
  const brandIdForTaskBoard = brandIdFromUrl || (selectedBrand ? selectedBrand.id : null);

  return <TaskBoard brandId={brandIdForTaskBoard} />;
};

// Settings sayfası için koruma bileşeni
const SettingsRouteGuard = ({ children }) => {
  const { selectedBrand } = useAuth();
  const demoBrandId = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';

  if (selectedBrand && selectedBrand.id === demoBrandId) {
    // Demo brand için settings sayfasına erişimi engelle ve anasayfaya yönlendir
    return <Navigate to="/" replace />;
  }

  return children;
};

// Glowy Lens: Efe her markada; diğer kullanıcılar yalnız Yataş grubu markalarından biri seçiliyken.
const GLOWY_LENS_EMAILS = ['efe@glowytics.com', 'efe@heyglowy.com'];
const YATAS_GROUP_BRAND_IDS = [
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
];
const GlowyLensRoute = ({ children }) => {
  const { user } = useAuth();
  if (GLOWY_LENS_EMAILS.includes(user?.email?.toLowerCase())) {
    return <ProtectedRoute>{children}</ProtectedRoute>;
  }
  return <ProtectedRoute allowBrandIds={YATAS_GROUP_BRAND_IDS}>{children}</ProtectedRoute>;
};

// TaskBoard sayfası için koruma bileşeni
const TaskBoardRouteGuard = ({ children }) => {
  const { selectedBrand } = useAuth();
  const demoBrandId = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';

  if (selectedBrand && selectedBrand.id === demoBrandId) {
    // Demo brand için Task Board'a erişimi engelle ve anasayfaya yönlendir
    return <Navigate to="/" replace />;
  }

  return children;
};

// BRANDING role route guard — defense-in-depth against direct URL navigation.
// BRANDING users should only see Market Insights / Social Intelligence pages.
const BRANDING_LANDING = '/market-insights/facebook-ads-library';
const BRANDING_ALLOWED_PREFIXES = [
  '/market-insights/',
  '/social-intelligence',
  '/brand-selector',
  '/profile',
  '/login',
  '/logout',
];
const BrandingRoleGate = () => {
  const { selectedBrand } = useAuth();
  const location = useLocation();

  if (selectedBrand?.currentUserRole !== 'BRANDING') {
    return null;
  }

  const path = location.pathname;
  const isAllowed = BRANDING_ALLOWED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix)
  );

  if (!isAllowed) {
    return <Navigate to={BRANDING_LANDING} replace />;
  }

  return null;
};

const PAGE_TITLES = {
  '/': 'Overview',
  '/overview': 'Overview',
  '/overview2': 'Overview',
  '/overview-v16': 'Overview v16',
  '/overview-v17': 'Overview',
  '/overviewv5': 'Overview V5',
  '/overviewv7': 'Overview V7',
  '/testingoverview': 'Testing Overview',
  '/__lab/testing-overview2': 'Testing Overview 2',
  '/lab/testing-overview2': 'Testing Overview 2',
  '/custom-report': 'Custom Report',
  '/custom-report/report-1': 'Kampanya Raporu',
  '/custom-report/report-2': 'Branding Raporu',
  '/custom-report/report-3': 'Performans Raporu',
  '/custom-report/report-4': 'Monthly Target Planner',
  '/custom-report/report-5': 'Kanal Kırılım Raporu (All)',
  '/custom-report/report-6': 'Medya Satın Alma Tablo Dönüştürücü',
  '/custom-report/report-7': 'Kanal Kırılım Raporu (Brand)',
  '/faturalama': 'Aylık Mecra Harcaması',
  '/harcama-faturasi': 'Spend Invoice',
  '/social/instagram': 'Instagram Stüdyosu',
  '/talepler': 'Marka Talepleri',
  '/kullanici-takip': 'Kullanıcı Takibi',
  '/kumbara-zeplin-49': 'Kumbara',
  '/linkedin-studyo': 'LinkedIn Stüdyosu',
  '/yeni-kullanicilar': 'Yeni Kullanıcılar',
  '/yeni-markalar': 'Yeni Markalar',
  '/wunder/planlar': 'Marka Planları',
  '/kampanya-soylemleri': 'Kampanya Söylemleri',
  '/glowyai/health-check': 'Account Health',
  '/grup/hupalupa': 'HUPALUPA Grubu · Patron Paneli',
  '/grup/hupalupa/faturalandirma': 'HUPALUPA Grubu · Faturalandırma',
  '/grup/hupalupa/faturalandirma-kopya': 'HUPALUPA Grubu · Faturalandırma (Kopya)',
  '/wall': 'Executive Wall',
  '/weekly-report': 'Haftalik Yonetici Raporu',
  '/app-overview': 'App Overview',
  '/ads-platforms': 'Ads Platforms',
  '/ads-platforms/google-ads': 'Google Ads',
  '/ads-platforms/meta-overview': 'Meta Overview',
  '/ads-platforms/meta-ads': 'Meta Ads',
  '/ads-platforms/tiktok-ads': 'TikTok Ads',
  '/ads-platforms/criteo': 'Criteo',
  '/ads-platforms/criteo-overview': 'Criteo Overview',
  '/ads-platforms/apple-search-ads': 'Apple Search Ads',
  '/ads-platforms/google-ads/overview': 'Google Ads Overview',
  '/ads-platforms/google-ads/search': 'Google Ads - Search',
  '/ads-platforms/google-ads/search-keyword-report': 'Search Keyword Report',
  '/ads-platforms/google-ads/search-keyword-report-v3': 'Search Keyword Report V3',
  '/ads-platforms/google-ads/ad-copy-report': 'Ad Copy Report',
  '/ads-platforms/google-ads/ad-copy-report-yenilio': 'Ad Copy Report — Yenilio',
  '/ads-platforms/google-ads/display': 'Google Ads - Display',
  '/ads-platforms/google-ads/demand-gen': 'Google Ads - Demand Gen',
  '/ads-platforms/google-ads/gdn-creatives': 'Google Ads - GDN Creatives',
  '/ads-platforms/google-ads/shopping': 'Google Ads - Shopping',
  '/ads-platforms/google-ads/pmax': 'Google Ads - Performance Max',
  '/ads-platforms/google-ads/pmax-assets': 'Google Ads - PMax Asset Performance',
  '/ads-platforms/google-ads/visibility': 'Google Ads - Arama Görünürlüğü & Ses Payı',
  '/ads-platforms/google-ads/impression-share': 'Google Ads - Gösterim Payı Tablosu',
  '/ads-platforms/google-ads/dsa': 'Google Ads - Dynamic Search',
  '/ads-platforms/google-ads/video': 'Google Ads - Video',
  '/ads-platforms/google-ads/app': 'Google Ads - App',
  '/ads-platforms/google-ads/audience-insights': 'Google Ads - Audience Insights',
  '/ads-platforms/meta-ads/creative-performance': 'Meta Ads - Creative Performance',
  '/ads-platforms/pinterest/creative-performance': 'Pinterest - Creative Performance',
  '/ads-platforms/tiktok-ads/creative-performance': 'TikTok Ads - Creative Performance',
  '/ads-platforms/google-ads/creative-performance': 'Google Ads - Creative Performance',
  '/ads-platforms/meta-ads/campaign-type': 'Meta Ads - Campaign Type',
  '/ads-platforms/meta-ads/engagement-monitor': 'Engagement Monitor (Canlı) - Meta / TikTok / YouTube',
  '/ads-platforms/tiktok-ads/campaign-type': 'TikTok Ads - Campaign Type',
  '/high5/funnel-performance': 'High5 - Funnel Performance',
  '/monthly-targets': 'Monthly Targets',
  '/labs/kpi-targets': 'Hedef vs Gerçekleşen',
  '/yatas/bulten': 'Aylık Bülten',
  '/yatas/takip': 'Dinamik Takip',
  '/yatas/kampanya-kodlari': 'Kampanya Kodları',
  '/yatas/pano': 'Performans Panosu',
  '/yatas/planlama': 'Medya Planlama & Asistan',
  '/yatas/davranis-segmentasyonu': 'Davranış Segmentasyonu',
  '/yatas/davranis-haritasi': 'Davranış Haritası',
  '/gbp/lokal': 'Lokal Performans',
  '/yatas/uyarilar-prototip': 'Uyarı Sistemi (Prototip)',
  '/meta/meta-audiences': 'Meta Audiences',
  '/meta/kitle-onerileri': 'Audience Suggestions',
  '/meta/meta-audience-insights': 'Meta Audience Insights',
  '/analytics/analytics-overview': 'Analytics Overview',
  '/analytics/ga4-overview': 'GA4 Overview',
  '/analytics/ga4-custom-dimensions': 'GA4 Custom Dimensions',
  '/analytics/ga4-audience': 'GA4 Audience',
  '/analytics/new-vs-returning-revenue': 'New vs Returning Revenue',
  '/analytics/session-engagement': 'Session Engagement (GA4)',
  '/analytics/hourly-order-analysis': 'Hourly Order Analysis',
  '/analytics/daily-funnel': 'Günlük Funnel',
  '/analytics/weekday-order-analysis': 'Weekday Order Analysis',
  '/high5/ltv': 'Müşteri LTV & Tekrar Satın Alma',
  '/high5/size-coverage': 'Ürün Beden Dağılımı',
  '/high5/feed-farki': 'Feed Farkı — Kaynak ↔ Reklam',
  '/high5/hedef-takip': 'Hedef vs Gerçekleşen — Günlük',
  '/high5/marka-kapsama': 'Marka Arama Kapsaması',
  '/high5/acik-artirma': 'Açık Artırma Analizi — Marka Arama',
  '/high5/haftalik-kpi': 'Haftalık KPI — Total / UnPaid / Paid',
  '/high5/mtd-hedef': 'MTD Ciro Hedefi',
  '/high5/haftalik-mail': 'Haftalık Mail Taslağı',
  '/analytics/creative-insights': 'Creative & Copy Insights',
  '/high5/marka-canli': 'Marka Canlı Takip',
  '/marka-canli': 'Marka Canlı Takip',
  '/high5/beden-birikimi': 'Ürün Bazlı Beden Birikimi',
  '/high5/ciro-stok': 'Ürün Ciro & Stok Takibi',
  '/high5/beden-kirigi': 'Haftalık Beden Kırığı',
  '/high5/satan-beden': 'En Çok Satan Ürünler — Beden Durumu',
  '/high5/urun-satislari': 'Ürün Satışları — Haftalık / Aylık',
  '/high5/yesterday': 'Yesterday',
  '/high5/fiyat-rekabeti': 'Günlük Fiyat Rekabeti',
  '/koton/ga4-360': 'GA4 360 İş Gerekçesi',
  '/grace/catalog': 'Ürün Kataloğu',
  '/paulmark/catalog': 'Ürün Kataloğu',
  '/analytics/adjust-overview': 'Adjust Overview',
  '/analytics/source-medium': 'Source / Medium',
  '/analytics/source-medium-monthly': 'Source / Medium (Monthly)',
  '/analytics/adjust-source-medium-monthly': 'Adjust Source / Medium (Monthly)',
  '/analytics/combined-traffic-sources': 'Combined Traffic Sources',
  '/analytics/product-performance': 'Product Performance',
  '/analytics/kampanya-urun-satis': 'Kampanyadan Satılan Ürünler',
  '/analytics/product-portfolio-analysis': 'Product Portfolio Analysis',
  '/analytics/channel-mix-reallocation-demo': 'Channel Mix Reallocation',
  '/analytics/price-elasticity-of-demand': 'Price Elasticity of Demand',
  '/analytics/seasonality-forecast-demo': 'Seasonality Forecast',
  '/analytics/rfm-lifecycle-demo': 'RFM Lifecycle',
  '/analytics/retention-drivers-demo': 'Retention Drivers',
  '/analytics/audience-segmentation-demo': 'Audience Segmentation',
  '/analytics/mmm-demo': 'Marketing Mix Modeling',
  '/analytics/period-analysis': 'Period Analysis',
  '/analytics/funnel': 'Funnel Analysis',
  '/analytics/revenue-forecasting': 'Revenue Forecasting',
  '/analytics/internal-search-terms': 'Internal Search Terms',
  '/budget/forecasting': 'Budget Forecasting',
  '/budget/media-planning-table': 'Media Planning',
  '/budget/media-plan-table': 'Media Plan',
  '/budget/simple-branding-forecast': 'Branding Forecast',
  '/market-insights/ads-library': 'Ads Library',
  '/market-insights/search-volume': 'Search Volume',
  '/market-insights/search-volume-matrix': 'Search Volume Matrix',
  '/market-insights/high5-search-research': 'Search Volume Radar',
  '/market-insights/google-trends': 'Google Trends',
  '/market-insights/keyword-discover': 'Keyword Discover',
  '/market-insights/youtube-radar': 'YouTube Radar',
  '/market-insights/instagram-radar': 'Instagram Radar',
  '/market-insights/instagram-comments': 'Instagram Comments Collector',
  '/market-insights/tiktok-radar': 'TikTok Radar',
  '/market-insights/app-radar': 'App Radar',
  '/market-insights/multipay-yorum-analizi': 'MultiPay Yorum Analizi',
  '/market-insights/facebook-ads-library': 'Facebook Ads Library',
  '/market-insights/ad-shelf-share': 'Ad Shelf Share',
  '/market-insights/google-ads-transparency': 'Google Ads Transparency',
  '/market-insights/youtube-trends': 'YouTube Trends',
  '/market-insights/youtube-ai': 'YouTube AI Araştırma',
  '/market-insights/rtbhouse-connect': 'RTB House API Test',
  '/market-insights/pinterest-test': 'Pinterest API Test',
  '/pinterest-dashboard': 'Pinterest Ads',
  '/market-insights/merchant-insights': 'Merchant Insights',
  '/market-insights/merchantinsights': 'Merchant Insights',
  '/market-insights/merchant-price-insights2': 'Merchant Price Insights',
  '/market-insights/category-seasonality': 'Category Seasonality',
  '/market-insights/campaign-calendar': 'Campaign Calendar',
  '/search-console/overview': 'Search Console Overview',
  '/search-console/monthly-queries': 'Search Console Monthly Queries',
  '/search-console/blog-seo': 'Blog SEO Takibi',
  '/ikas/overview': 'Ikas Overview',
  '/ikas/product-performance': 'Ikas Product Performance',
  '/ikas/custom-segments': 'Ikas Customer Segments',
  '/ikas/buying-segment': 'Ikas Brand Purchase Behavior',
  '/ikas/category-segments': 'Ikas Category Segments',
  '/ikas/product-customer-segments': 'Ikas Product Customer Segments',
  '/ikas/loyalty': 'Ikas Loyalty',
  '/ikas/monthly-fetch': 'Ikas Monthly Fetch',
  '/shopify/overview': 'Shopify Overview',
  '/shopify/product-performance': 'Shopify Product Performance',
  '/shopify/stock-coverage': 'Shopify Stock Coverage',
  '/shopify/custom-segments': 'Shopify Customer Segments',
  '/shopify/buying-segment': 'Shopify Brand Purchase Behavior',
  '/shopify/category-segments': 'Shopify Category Segments',
  '/shopify/product-customer-segments': 'Shopify Product Customer Segments',
  '/shopify/loyalty': 'Shopify Loyalty',
  '/woocommerce/overview': 'WooCommerce Overview',
  '/woocommerce/product-performance': 'WooCommerce Product Performance',
  '/woocommerce/custom-segments': 'WooCommerce Customer Segments',
  '/woocommerce/buying-segment': 'WooCommerce Brand Purchase Behavior',
  '/woocommerce/category-segments': 'WooCommerce Category Segments',
  '/woocommerce/product-customer-segments': 'WooCommerce Product Customer Segments',
  '/woocommerce/loyalty': 'WooCommerce Loyalty',
  '/adjust/overview': 'Adjust Overview',
  '/adjust/traffic-acquisition': 'Adjust Traffic Acquisition',
  '/merchant-center/performance': 'Merchant Center Performance',
  '/merchant-center/price-benchmark': 'Merchant Center Price Benchmark',
  '/merchant-center/inventory': 'Merchant Center Inventory',
  '/merchant-center/inventory-performance': 'Merchant Center Inventory Performance',
  '/merchant-center/variant-performance': 'Merchant Center Variant Performance',
  '/merchant-center/custom-labels': 'Merchant Center Custom Labels',
  '/merchant-center/discount-tracking': 'Marka Bazlı Günlük İndirim Takibi',
  '/settings': 'Settings',
  '/my-account': 'My Account',
  '/brand-selector': 'Brand Selector',
  '/live-snippet': 'Live Snippet',
  '/ai-chat': 'AI Chat',
  '/glowy-ai': 'Glowy AI',
  '/glowyai-marketing-assistant': 'Glowy AI Assistant',
  '/hourly-performance': 'Hourly Performance',
  '/creative-builder': 'Creative Builder',
  '/ads-builder': 'Ads Builder',
  '/momentum-builder': 'Momentum Builder',
  '/competitors/market-share': 'Market Share',
  '/competitors/share-of-voice': 'Share of Voice',
  '/sahlanma': 'Şahlanma Komuta Merkezi',
  '/hq/admin/smart-campaigns': 'Smart Campaign Engine',
  '/hq/admin/smart-campaigns/:brandId/:configId': 'Campaign Detail',
  '/hq/admin/mc-disapproval-monitor': 'Merchant Center — Disapproval Monitor',
  '/hq/admin/google-ads-clone': 'Google Ads — Search Campaign Cloner',
  '/hq/admin': 'Admin Panel',
  '/hq/backlog': 'Proje Mezarlığı',
  '/hq/gbp': 'Google Business Profile',
  '/gbp/locations': 'Google Business Profile — Lokasyonlar',
  '/hq/websummit': 'Web Summit · Company Brief',
  '/hq/narrative-flow': 'Glowytics Value Story',
  '/hq/on-turkiye': 'glowy · Agency Profile',
  '/hq/klaud-outlet': 'glowy · Klaud Outlet',
  '/hq/temizmama-teklif': 'Glowytics · Temizmama',
  '/hq/coffras-akl-teklif': 'glowy · Coffras ve AKL Sigorta',
  '/hq/skechers-glowytics': 'Glowytics · Skechers Teklif',
  '/hq/grup-glowytics': 'Glowytics · Dört Marka Teklif',
  '/hq/uc-marka-glowytics': 'Glowytics · Üç Marka Teklif',
  '/hq/on-glowytics': 'Glowytics · On Türkiye Teklif',
  '/pixel-analytics': 'Pixel Analytics',
  '/labs/google-ads-audiences': 'Labs - Google Ads Audiences',
  '/labs/meta-creative-test': 'Labs - Meta Creative Test',
  '/labs/ads-transparency': 'Labs - Ads Transparency',
  '/labs/meta-ad-library': 'Labs - Meta Ad Library',
  '/labs/google-ads-campaigns': 'Labs - Google Ads Campaigns',
  '/labs/meta-ads-campaigns': 'Labs - Meta Ads Campaigns',
  '/labs/meta-catalog-creator': 'Labs - Meta Catalog Creator',
  '/labs/banner-heatmap': 'Labs - Banner Click Heatmap',
  '/labs/meta-media-library': 'Labs - Meta Media Library',
  '/labs/meta-ai-enhancer': 'Labs - Meta AI Enhancer',
  '/labs/meta-image-campaign': 'Labs - Meta Image Campaign',
  '/labs/meta-instagram-debug': 'Labs - Instagram Debug',
  '/labs/meta-pages': 'Labs - Meta Pages',
  '/labs/merchant-ai-studio': 'Labs - Merchant AI Studio',
  '/labs/google-trends': 'Labs - Google Trends',
  '/labs/influencer-probe': 'Labs - Influencer Probe',
  '/labs/adjust-test': 'Labs - Adjust Test',
  '/labs/adjust-attribution-compare': 'Labs - Adjust Attribution Compare',
  '/labs/keyword-planner': 'Labs - Keyword Planner',
  '/labs/search-campaign-wizard': 'Labs - Search Campaign Wizard',
  '/labs/merchant-center-test': 'Labs - Merchant Center Test',
  '/labs/live-today': 'Labs - Live Today',
  '/labs/search-console': 'Labs - Search Console',
  '/labs/shopify': 'Labs - Shopify',
  '/labs/poc-showcase': 'Labs - PoC Showcase',
  '/labs/sendgrid-test': 'Labs - SendGrid Test',
  '/labs/gbp-test': 'Labs - Google Business Profile',
  '/labs/woocommerce-test': 'Labs - WooCommerce',
  '/labs/ikas': 'Labs - Ikas',
  '/labs/tsoft-sales': 'Labs - T-Soft Sales',
  '/labs/site-meta-crawler': 'Labs - Site Title & Description Tarayıcı',
  '/analytics/daily-traffic': 'Analytics - Daily GA4 Traffic & Transactions',
  '/analytics/page-source-medium-live': 'Analytics - Page → Source/Medium (Canlı GA4)',
  '/labs/google-ads-youtube': 'Labs - YouTube Campaigns',
  '/labs/gemini': 'Labs - Gemini',
  '/labs/deep-research': 'Labs - Deep Research',
  '/labs/maps-grounding': 'Labs - Maps Grounding',
  '/market-insights/place-reviews': 'Location & Review Explorer',
  '/xml-feed-analyzer': 'XML Feed Analyzer',
  '/meta-catalog/sets': 'Meta Catalog Sets',
  '/meta-catalog/products-sets': 'Meta Catalog Products',
  '/345435gurgencler': 'Yenilio Strateji Planı',
  '/high5/price-comparison': 'Fiyat Karşılaştırması',
  '/high5/price-by-seller': 'Price by Seller',
  '/skechers/price-comparison': 'Price Comparison',
  '/kixz/price-comparison': 'Price Comparison',
  '/propia/price-tracking': 'Price Tracking',
  '/skechers/price-vs-benchmark': 'Rival Prices vs Google Benchmark',
  '/competitor/wunder-price': 'Fiyat Rekabeti',
  '/wunder/cost-per-sale': 'Bir Satışın Maliyeti',
  '/budget/salomon-wunder-eylul-kasim-2026': 'Salomon × Wunder · Eyl-Kas 2026 Teklifi',
  '/budget/birkenstock-wunder-ekim-aralik-2026': 'Birkenstock × Wunder · Eki-Ara 2026 Teklifi',
  '/reports/meta-catalog-product-spend': 'Meta Ads - Product Spend',
  '/ads-platforms/meta-ads/product-spend': 'Meta Ads - Product Spend',
  '/budget/europcar-programatik-2026': 'Europcar · Programatik Medya Planı',
  '/r/europcar-blog': 'Europcar · Blog Envanteri',
  '/icerik/studyo': 'İçerik Stüdyosu',
  '/r/europcar-ga4': 'Europcar · GA4 Ölçüm Panosu',
  '/r/europcar-kaynak': 'Europcar · Kaynak Raporu',
  '/r/google-ads-donusum': 'Google Ads · Dönüşüm Kırılımı',
  '/r/canon-coral': 'Canon · Coral Campaign Report',
  '/blackspade/donusum-denetimi': 'BlackSpade · Dönüşüm & ROAS Denetimi',
  '/r/europcar-datalayer': 'Europcar · dataLayer Spesifikasyonu',
  '/r/europcar-checkout-denetimi': 'Europcar · Checkout Etiketleme Denetimi',
  '/r/europcar-arama': 'Europcar · Araç Arama Talebi',
  '/r/europcar-google-isim': 'Europcar · Google Kayıt Adları',
  '/r/europcar-login': 'Europcar · Üye Girişi Ölçümü',
  '/r/europcar-google-puan': 'Europcar · Google Ortalama Puanı',
  '/r/kixx-youtube': 'KIXX · YouTube TR İçerik Araştırması',
  '/r/hupalupa-youtube': 'HUPALUPA · YouTube Kanal Teşhisi',
  '/r/hupalupa-anasayfa-akis': 'HUPALUPA Store · Ana Sayfadan Kategoriye Akış',
  '/r/hupalupa-zoo-family': 'HUPALUPA Store · The Zoo Family',
  '/r/hupalupa-zoo-family-en': 'HUPALUPA Store · The Zoo Family (EN)',
  '/r/hupalupa-kanal-satislari': 'HUPALUPA Store · Kanal Bazlı Satışlar',
  '/reports/anasayfa-kategori-akisi': 'Ana Sayfa Akışı · Kategori Dağılımı',
  '/reports/hupalupa-lokasyon': 'HUPALUPA · Lokasyon Röntgeni',
  '/r/divanev-lokasyon': 'Divanev · Lokasyon Özeti',
  '/r/yatas-bedding-geo': 'Yataş Bedding · GEO Sağlık Kontrolü',
  '/r/gurgencler-cx-yoy-2026': 'Gürgençler · CX YoY Rapor',
  '/r/gurgencler-q3': 'Gürgençler · Q3 Dönem Raporu',
  '/r/gurgencler-bts-2026': 'Gürgençler · 2026 BTS Medya Planı',
  '/r/gurgencler-lansman-2026': 'Gürgençler · Apple Lansman Dönemi 2026',
  '/r/gurgencler-lansman-iletisim-2026': 'Gürgençler · Lansman İletişim Kurgusu 2026',
  '/r/gurgencler-lansman-fikirler': 'Gürgençler · Lansman Fikirleri',
  '/r/clubsporium-teklif': 'Club Sporium · Dijital Pazarlama Teklifi',
  '/r/common-leisure-denetim': 'Common Leisure · Dijital Altyapı Röntgeni',
  '/r/yorstruly-denetim': 'Yorstruly · Dijital Büyüme Röntgeni',
  '/r/yorstruly-teklif': 'Yorstruly · Teklif',
  '/r/under-armour-2027': 'Under Armour Türkiye · 2027 Planı',
  '/r/multinet-tanisma': 'Multinet Up · Dışarıdan Bakınca',
  '/r/baqa-seo': 'Baqa · Arama ve Yapay Zekâ',
  '/r/yatas-geo-sunum': 'Yataş · Yapay Zekâ Görünürlüğü',
  '/r/triomobil-denetim': 'Trio Mobil · Dışarıdan Bakınca',
  '/r/triomobil-ozet': 'Trio Mobil · Özet',
  '/r/coffras-web': 'Coffras · Web Projesi',
  '/r/coffras-web/prototip': 'Coffras · Site Prototipi',
  '/r/regalien-ozet': 'Régalien · Performans Özeti',
  '/r/temizmama-sunum': 'Temizmama · Glowy',
  '/r/temizmama-yonetim': 'Temizmama · Glowy',
  '/r/temizmama-branding': 'Temizmama · Glowy',
  '/r/juju-gorsel-kiyas': 'JujuMood · Benzer Markalar',
  '/r/high5-on': 'On at High5 · In Numbers',
  '/r/high5-on-etki': 'High5 · On Etki Çalışması',
  '/r/high5-asics-indirim': 'High5 · ASICS İndirim Dönemi',
  '/r/high5-on-haftalik': 'High5 · On Haftalık Görünüm',
  '/r/high5-ekim': 'High5 · Ekim 2026 Değerlendirmesi',
  '/r/yorstruly-kasim': 'Yorstruly · Kasım 2026 Çalışma Durumu',
  '/r/high5-on-calisma-ilkeleri': 'High5 · On Türkiye Çalışma İlkeleri',
  '/r/on-fw26-rehber': 'High5 · On FW26 B2B Rehberi',
  '/r/high5-rm-dagilimi': 'High5 · Yeni Kullanıcı / Remarketing',
  '/r/high5-kaynak-buyume': 'High5 · Kaynak Bazlı Ciro',
  '/r/high5-kanal-hunisi': 'High5 · Kanal Hunisi',
  '/r/high5-mobil-donusum': 'High5 · Mobil Dönüşüm',
  '/r/high5-mobil-ozet': 'High5 · Mobil Dönüşüm Özeti',
  '/r/high5-on-google-ads': 'High5 · Google Ads',
  '/r/high5-meta-ads': 'High5 · Meta Ads',
  '/common-leisure/video': 'Common Leisure · Video Stüdyosu',
  '/r/common-leisure-teklif': 'Common Leisure · Teklif',
  '/r/glowy-studio-teklif': 'Yataş Grubu · Glowy Studio Çerçeve Teklifi',
  '/r/idefix-studio-teklif': 'idefix · Glowy Studio Çerçeve Teklifi',
  '/r/idefix-uspolo-cerceve': 'idefix × U.S. Polo · Çerçeve Seçenekleri',
  '/reports/learning-resources': 'Learning Resources · Numberblocks Talep Röntgeni',
  '/budget/hupalupa-son-ceyrek-2026': 'HUPALUPA Store · Son Çeyrek 2026',
  '/reports/hupalupa-performans-2026': 'HUPALUPA Store · Performans Temmuz – Ekim 2026',
  '/reports/playmobil-hupalupa-2026': 'PLAYMOBIL · HUPALUPA Store reklam çalışmaları',
  '/reports/hupalupa-kasim-aralik-2026': 'HUPALUPA Store · Kasım – Aralık 2026 yol haritası',
  '/reports/crayola': 'Crayola Talep Röntgeni',
  '/r/gurgencler-gunluk-veri': 'Gürgençler · Günlük Ham Veri',
  '/labs/image-editor': 'Labs - Image Editor (Gemini)',
  '/labs/image-enhance': 'Labs - Görsel İyileştirici (Gemini)',
  '/labs/image-equalize': 'Labs - Görsel Boyut Eşitleyici',
  '/labs/png-background': 'Labs - PNG Background Fitter',
  '/labs/platform-resizer': 'Labs - Platform Resizer (Nano Banana)',
  '/labs/product-concept': 'Labs - Ürün Konsept Stüdyosu (Nano Banana)',
  '/labs/joyico-studio': 'Labs - Joyico Ahşap Oyuncak Stüdyosu (Nano Banana)',
  '/labs/inviter-ads': 'Labs - inviter Install Reklam Stüdyosu (Nano Banana)',
  '/labs/bq-channel-performance': 'Labs - BQ Kanal Performansı (Test)',
  '/labs/pastperfect-studio': 'Labs - Past Perfect Çerçeve Stüdyosu',
  '/glowy-studio': 'Glowy Studio',
  '/cerceve-atolyesi': 'Çerçeve Atölyesi',
  '/labs/idefix-uretim': 'idefix · Üretim izleme',
  '/leadler': 'Lead Kutusu',
  '/cro/widgets': 'Widgets · Glowy OnSite',
  '/cro/kaynak-takibi': 'Kaynak Takibi · Glowy OnSite',
  '/cro/kaynak-takibi/veri': 'Toplanan Veri · Kaynak Takibi',
  '/cro/kaynak-takibi/kurulum': 'GTM Setup · Source Tracking',
  '/cro/asistan': 'Glowy Desk · Glowy OnSite',
  '/email': 'Glowy Mail',
  '/cro/pdp-editor': 'Widgets · Glowy OnSite',
  '/feed-builder': 'Glowy Studio',
  '/ads-content': 'Ads Content (Live Ad Creatives)',
  '/meta-static-assets': 'Meta Statik Görselleri',
  '/budget-overview': 'Bütçe Genel Bakış',
  '/login': 'Login',
  '/signup': 'Sign Up',
  '/forgot-password': 'Forgot Password',
  '/reset-password': 'Reset Password',
};

function PageTitleUpdater() {
  const location = useLocation();
  useEffect(() => {
    const title = PAGE_TITLES[location.pathname];
    document.title = title ? `${title} | Glowytics` : 'Glowytics Marketing Intelligence Platform';
  }, [location.pathname]);
  return null;
}

/**
 * Kısıtlı marka rolleri (FINANCE / GBP) tam menüyü değil, tek
 * maddelik RestrictedSidebar'ı görür — ana sidebar açılışta yetkisi olmayan
 * uçlara istek atıyor ve o hesaplar hepsinden 403 alır.
 */
function SidebarSwitch({ onHoverChange, variant }) {
  const { selectedBrand } = useAuth();
  return kisitliTip(selectedBrand)
    ? <RestrictedSidebar onHoverChange={onHoverChange} />
    : <Sidebar onHoverChange={onHoverChange} variant={variant} />;
}

// v16 çerçevesini deneyen sayfalar: gri zemin + gri sidebar + yuvarlak beyaz panel.
// Listede olmayan her sayfa eskisiyle BİREBİR aynı kabukta çizilir.
const V16_SHELL_PATHS = ['/overview-v16', '/overview-v17'];

function AppShell({ children }) {
  const { pathname } = useLocation();
  if (V16_SHELL_PATHS.includes(pathname)) {
    return (
      <div className="v16-app">
        <BrandingRoleGate />
        <SidebarSwitch variant="gray" />
        <main className="v16-panel">
          <div key={pathname} className="v16-enter">{children}</div>
        </main>
        <QuickTaskTab />
      </div>
    );
  }
  return (
    <div className="flex overflow-x-hidden max-w-[100vw]">
      <BrandingRoleGate />
      <SidebarSwitch />
      <main className="main-content ml-16">{children}</main>
      <QuickTaskTab />
    </div>
  );
}

function App() {
  // Sidebar açılınca içeriğin ÜSTÜNE kayar (overlay); ana içerik hep ml-16'da kalır.
  // Eskiden açılışta App state'i değişip tüm sayfa yeniden çiziliyor ve içerik
  // 192px itilip yeniden diziliyordu → grafikli sayfalarda takılma.

  return (
    <Router>
      <PageTitleUpdater />
      <AuthProvider>
        <BrandProvider>
        <AccountProvider>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                style: {
                  background: '#059669',
                },
              },
              error: {
                duration: 4000,
                style: {
                  background: '#DC2626',
                },
              },
            }}
          />
          <Routes>
            {/* Public Routes */}
            <Route path="/frontpage" element={<FrontPage />} />
            <Route path="/kedikopekburc" element={<KediKopekBurc />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment-callback" element={<PaymentCallback />} />
            <Route path="/ikas-connect" element={<IkasConnect />} />
            <Route path="/shopify-connect" element={<ShopifyConnect />} />
            {/* High5 haftalık net satış — GİRİŞ YOK, sidebar YOK, sadece logo.
                Dışarıya verilen paylaşım linki; veri /api/public-reports'tan
                gelir (o uç da auth'suz). Adres rastgele slug ile gizlenmiştir
                (config/publicReportLinks.js), erişim kısıtı bilinçli olarak yok. */}
            <Route path={HIGH5_NET_SALES_PATH} element={<High5NetSalesPublic />} />
            {/* High5 mobil dönüşüm — GİRİŞ YOK. 6 slaytlık özet deste (/r/high5-mobil-ozet ile aynı);
                uç çağrılmıyor. */}
            <Route path={HIGH5_MOBIL_DONUSUM_PATH} element={<High5MobilDonusumPublic />} />
            {/* Wunder × Birkenstock — GİRİŞ YOK. Meta etkileşim kampanyasının günlük
                performansı + ikas'tan Birkenstock'un günlük online satışı. Aynı
                public uç ailesi, aynı gizli-slug disiplini. */}
            <Route path={WUNDER_BIRKENSTOCK_PATH} element={<WunderBirkenstockPublic />} />
            {/* Yataş Grup · AI Visibility — GİRİŞ YOK, sidebar YOK. Panelin /ai-visibility
                sayfasının aynısı (publicSlug modu); veri /api/ai-visibility/public/<slug>. */}
            <Route path={YATAS_AI_VISIBILITY_PATH} element={<YatasAiVisibilityPublic />} />
            {/* Mimic Data Analyst vaka raporu — sidebar YOK, sadece efe@heyglowy.com.
                Marka seçimi gerekmiyor; içerik markadan bağımsız statik bir rapor. */}
            <Route path="/r/mimic-data-analyst-case" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                <MimicCaseReport />
              </ProtectedRoute>
            } />
            {/* On Türkiye teklif eki sunumu — sidebar YOK (tam ekran deck),
                marka seçimi gerekmiyor; içerik markadan bağımsız statik bir sunum. */}
            <Route path="/hq/on-turkiye" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <OnTurkiyeDeck />
              </ProtectedRoute>
            } />
            {/* Klaud Outlet teklif eki sunumu, On Türkiye deck'inin Türkçe uyarlaması.
                Sidebar YOK, marka seçimi gerekmiyor. Kaynak: /home/glowyadmin/deck-src/klaud-outlet */}
            <Route path="/hq/klaud-outlet" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <KlaudOutletDeck />
              </ProtectedRoute>
            } />
            {/* GlowyAI'ın sohbette hazırladığı sunum. Sidebar YOK (tam ekran deck); marka
                linkteki ?b= parametresinden gelir, erişimi backend kontrol eder. */}
            <Route path="/glowyai/sunum/:id" element={
              <ProtectedRoute requireBrand={false}>
                <GlowyaiSunum />
              </ProtectedRoute>
            } />
            {/* Temizmama teklif sunumu, Klaud deck'inin uyarlaması. Sidebar YOK, marka seçimi
                gerekmiyor. Kaynak: /home/glowyadmin/deck-src/temizmama-teklif */}
            <Route path="/hq/temizmama-teklif" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <TemizmamaTeklifDeck />
              </ProtectedRoute>
            } />
            {/* Coffras ve AKL Sigorta teklifi (web, kurumsal kimlik, aylık sosyal medya/SEO/reklam).
                Sidebar YOK, marka seçimi gerekmiyor. Kaynak: /home/glowyadmin/deck-src/coffras-akl-teklif */}
            <Route path="/hq/coffras-akl-teklif" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <CoffrasAklTeklifDeck />
              </ProtectedRoute>
            } />
            {/* Skechers Türkiye tek sayfa Glowytics teklifi (yatay A4). Sidebar YOK,
                marka seçimi gerekmiyor. Kaynak: /home/glowyadmin/deck-src/skechers-glowytics */}
            <Route path="/hq/skechers-glowytics" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <SkechersGlowyticsOffer />
              </ProtectedRoute>
            } />
            {/* Klaud, Skechers, Brooks, Hunter toplu Glowytics teklifi, 3 slayt. Sidebar YOK.
                Kaynak: /home/glowyadmin/deck-src/grup-glowytics */}
            <Route path="/hq/grup-glowytics" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <GrupGlowyticsOffer />
              </ProtectedRoute>
            } />
            {/* Skechers, Brooks, Hunter (Klaud hariç) toplu Glowytics teklifi, 3 slayt. Sidebar YOK.
                Kaynak: /home/glowyadmin/deck-src/uc-marka-glowytics */}
            <Route path="/hq/uc-marka-glowytics" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <UcMarkaGlowyticsOffer />
              </ProtectedRoute>
            } />
            {/* On Türkiye Glowytics + GA4 Web Entegrasyonu teklifi, 2 slayt. Sidebar YOK.
                Kaynak: /home/glowyadmin/deck-src/on-glowytics */}
            <Route path="/hq/on-glowytics" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <OnGlowyticsOffer />
              </ProtectedRoute>
            } />
            {/* KIXX YouTube TR içerik araştırması — sidebar YOK. KIXX platformda
                marka DEĞİL (statik site müşterisi), o yüzden allowBrandIds değil
                requireBrand={false} + e-posta izni. İçerik markadan bağımsız. */}
            <Route path="/r/kixx-youtube" element={
              <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com", "access@heyglowy.com"]}>
                <KixxYoutubeReport />
              </ProtectedRoute>
            } />
            {/* HUPALUPA YouTube kanal teşhisi + TR pazar araştırması — sidebar YOK.
                KIXX'ten farklı: Hupalupa platformda GERÇEK marka, o yüzden allowBrandIds
                (HupalupaGoReport deseni — Eğlence + Hupalupa, ikisi de kabul). */}
            <Route path="/r/hupalupa-youtube" element={
              <ProtectedRoute allowBrandIds={['9e3c368d-d70d-4ba4-9506-fa0f65b526f7', 'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                <HupalupaYoutubeReport />
              </ProtectedRoute>
            } />
            {/* Ana sayfadan hangi kategoriye akıldığının şeması — sidebar YOK.
                Store markası (cb6bbe2d…) raporun konusu; Eğlence markası da
                aynı müşteri olduğu için kabul ediliyor (Hupalupa deseni). */}
            <Route path="/r/hupalupa-anasayfa-akis" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                <HupalupaAnasayfaAkis />
              </ProtectedRoute>
            } />
            {/* Gürgençler & Yenilio — organik sonuçlarda marka ikonu (favicon)
                teşhisi + aksiyon planı. Sidebar YOK: müşteriye PDF olarak
                gönderilecek bir belge, tam ekran basılıyor. Rapor iki markayı
                birden kapsadığı için allowBrandIds çoklu (Hupalupa deseni). */}
            {/* HUPALUPA Store — son çeyrek 2026 stratejisi ve bütçe önerisi.
                14 slayt, 16:9, apple.com dili. Sidebar YOK: müşteriye PDF olarak
                gidiyor. Slayt kaynağı src/pages/hupalupa-q4-2026/, üretmek için
                o klasördeki build.js. Rakamlar dondurulmuş, canlı API'ye bağlı
                DEĞİL: sunulan bir plan belgesi her açılışta oynamamalı. */}
            <Route path="/budget/hupalupa-son-ceyrek-2026" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                <HupalupaQ4_2026 />
              </ProtectedRoute>
            } />
            {/* HUPALUPA Store — performans raporu, 1 Temmuz – 16 Ekim 2026. 21 slayt,
                satılan markalar + NeeDoh/Playmobil/Learning Resources bölümü. Sidebar YOK:
                müşteriye PDF olarak gidiyor. Kaynak src/pages/hupalupa-performans-2026/,
                rakamlar dondurulmuş (veri-hazirla.js ile tazelenir). */}
            <Route path="/reports/hupalupa-performans-2026" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                <HupalupaPerformans2026 />
              </ProtectedRoute>
            } />
            {/* HUPALUPA Store — Kasım – Aralık 2026 yol haritası. 24 slayt: Ekim, takvim,
                ürün/marka/stok, Kara Cuma + yılbaşı çerçeveleri, bütçe. Sidebar YOK.
                Kaynak src/pages/hupalupa-kasim-aralik-2026/, rakamlar dondurulmuş. */}
            <Route path="/reports/hupalupa-kasim-aralik-2026" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                <HupalupaKasimAralik2026 />
              </ProtectedRoute>
            } />
            {/* PLAYMOBIL × HUPALUPA Store — reklam çalışmaları, 12 Ağustos – 18 Ekim 2026.
                15 slayt, PLAYMOBIL ekibi toplantısı için. Sidebar YOK, PDF olarak da iniyor.
                Kaynak src/pages/playmobil-hupalupa-2026/, rakamlar dondurulmuş. */}
            <Route path="/reports/playmobil-hupalupa-2026" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                <PlaymobilHupalupa2026 />
              </ProtectedRoute>
            } />
            {/* Learning Resources & Numberblocks — Hupalupa'ya gelecek marka için
                Türkiye ve global talep röntgeni. 12 slayt, 16:9, apple.com dili.
                Sidebar YOK: müşteriye PDF olarak gidiyor. Slayt kaynağı
                src/pages/learning-resources/, üretmek için o klasördeki build.js. */}
            <Route path="/reports/learning-resources" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                <LearningResourcesTalep />
              </ProtectedRoute>
            } />
            {/* Crayola — Hupalupa'ya gelecek ikinci marka için dünya ve Türkiye
                talep röntgeni. 20 slayt, 16:9, apple.com dili. Sidebar YOK.
                Slayt kaynağı src/pages/crayola/, üretmek için o klasördeki build.js. */}
            <Route path="/reports/crayola" element={
              <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                <CrayolaTalep />
              </ProtectedRoute>
            } />
            {/* Gürgençler — Apple lansman dönemi (Eylül 2026) hazırlık sunumu.
                29 slayt, 16:9, beyaz. Sidebar YOK: toplantıda tam ekran
                gösteriliyor ve PDF olarak basılıyor. Slayt kaynağı
                src/pages/gurgencler-lansman/, üretmek için o klasördeki build.js. */}
            <Route path="/r/gurgencler-lansman-2026" element={
              <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                <GurgenclerLansman2026 />
              </ProtectedRoute>
            } />
            {/* Gürgençler — aynı lansman dönemi için dört aşamalı iletişim kurgusu.
                Analiz sunumundan AYRI bir belge (o sunum olduğu gibi duruyor):
                31 slayt, apple.com tasarım dili. Kaynak src/pages/gurgencler-iletisim/,
                üretmek için o klasördeki build.js. */}
            <Route path="/r/gurgencler-lansman-iletisim-2026" element={
              <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                <GurgenclerIletisim2026 />
              </ProtectedRoute>
            } />
            {/* Gürgençler — aynı lansman dönemi, 5 slaytlık fikir gösterimi.
                Uzun kurgu sunumunun kısa kardeşi. Kaynak src/pages/gurgencler-fikirler/. */}
            <Route path="/r/gurgencler-lansman-fikirler" element={
              <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                <GurgenclerFikirler />
              </ProtectedRoute>
            } />
            {/* Europcar — organik arama performansı, ağustos 2026 durumu ve yıllık
                karşılaştırma. 16 slayt. Kaynak src/pages/europcar-seo/, üretmek için
                o klasördeki build.js (deck-data.json'u tazelemek ayrı bir adım). */}
            <Route path="/r/europcar-organik-arama" element={
              <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                <EuropcarSeoRaporu />
              </ProtectedRoute>
            } />
            {/* Europcar — 21 Tem 2026'dan bu yana yapılan işlerin özeti (SEO, içerik, GBP,
                ölçüm ve Google Ads gözlemleri). Kaynak src/pages/europcar-calisma-ozeti/. */}
            <Route path="/r/europcar-calisma-ozeti" element={
              <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                <EuropcarCalismaOzeti />
              </ProtectedRoute>
            } />
            {/* Europcar — site geçişinden bugüne değerlendirme (SEO, kanal, ölçüm, rakip arama payı).
                Kaynak src/pages/europcar-gecis-degerlendirme/. */}
            <Route path="/r/europcar-gecis-degerlendirme" element={
              <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                <EuropcarGecisDegerlendirme />
              </ProtectedRoute>
            } />
            {/* Club Sporium — satış toplantısı için dijital pazarlama teklifi.
                Kaynak src/pages/clubsporium-teklif/, CSS'i fikirler sunumuyla ortak. */}
            <Route path="/r/clubsporium-teklif" element={
              <ProtectedRoute allowBrandIds={['8a56e912-0359-49fc-8804-f6e20a4d4a1d']}>
                <ClubSporiumTeklif />
              </ProtectedRoute>
            } />
            {/* Common Leisure — dijital altyapının DIŞARIDAN denetimi, 14 slayt.
                Marka platformda kayıtlı değil (ölçüm tamamen açık kaynaklardan
                yapıldı), o yüzden marka kilidi değil e-posta kilidi var.
                Kaynak src/pages/common-leisure-denetim/; yeniden üretmek için o
                klasörde build.js sonra pdf.js. */}
            {/* Common Leisure — dijital pazarlama ve site yönetimi teklifi, 7 slayt.
                Aylık bedel deck-data.json'daki `teklif.aylik`; değişirse o klasörde
                build.js sonra pdf.js. Denetim sunumuyla aynı e-posta kilidi. */}
            {/* Özel notlar — sadece Efe, sidebar YOK, adres rastgele slug.
                İçerik backend'den (/api/ozel-notlar, e-posta kilitli), pakette yok. */}
            <Route path="/n/:slug" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                <OzelNot />
              </ProtectedRoute>
            } />
            <Route path="/r/common-leisure-teklif" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <CommonLeisureTeklif />
              </ProtectedRoute>
            } />
            {/* Multinet Up — tanışma sunumu + dijital altyapının DIŞARIDAN denetimi, 18 slayt
                (23 Eyl 2026 toplantısı). E-posta kilidi: Multinet hesabı var ama sunum
                müşteriye PDF olarak gidiyor, panel içinden sadece biz açıyoruz.
                Kaynak src/pages/multinet-tanisma/; yeniden üretmek için o klasörde build.js. */}
            <Route path="/r/multinet-tanisma" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <MultinetTanisma />
              </ProtectedRoute>
            } />
            {/* Trio Mobil: tanışma sunumu + DIŞARIDAN tam denetim (platformda marka yok).
                E-posta kilidi, sunum PDF olarak gidiyor. Kaynak src/pages/triomobil-denetim/. */}
            <Route path="/r/triomobil-denetim" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <TrioMobilDenetim />
              </ProtectedRoute>
            } />
            {/* Trio Mobil denetiminin 3 slaytlık özeti (7 Eki 2026), aynı kilit. Kaynak src/pages/triomobil-ozet/. */}
            <Route path="/r/triomobil-ozet" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <TrioMobilOzet />
              </ProtectedRoute>
            } />
            {/* Coffras web sitesi projesi kapsam sunumu, 12 slayt (14 Eki 2026). Platformda marka yok,
                e-posta kilidi. Kaynak src/pages/coffras-web/. */}
            <Route path="/r/coffras-web" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <CoffrasWeb />
              </ProtectedRoute>
            } />
            {/* Coffras site prototipi (15 Eki 2026): ana sayfa, 3 hizmet landing'i, AKL, iletişim; masaüstü/mobil.
                Aynı e-posta kilidi. Kaynak src/pages/coffras-web/prototip.html. */}
            <Route path="/r/coffras-web/prototip" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <CoffrasPrototip />
              </ProtectedRoute>
            } />
            {/* Régalien Eylül 2026 performans özeti, 3 slayt (8 Eki 2026). Woo sipariş + GA4 oturum + harcama.
                Régalien markasına kilitli, kaynak src/pages/regalien-ozet/. */}
            <Route path="/r/regalien-ozet" element={
              <ProtectedRoute allowBrandIds={['8dcc7042-90dd-442c-a6db-588fc97da3d1']}>
                <RegalienOzet />
              </ProtectedRoute>
            } />
            {/* Temizmama konkuru tanışma sunumu (29 Eyl 2026), tam ekran, sidebar YOK. Sunum müşteriye PDF olarak gidiyor.
                Temizmama markasına kilitli (allowBrandIds), kaynak src/pages/temizmama-sunum/. */}
            <Route path="/r/temizmama-sunum" element={
              <ProtectedRoute allowBrandIds={['675cf508-b160-4767-b75e-43be853e3e59']}>
                <TemizmamaSunum />
              </ProtectedRoute>
            } />
            {/* Temizmama konkuru yönetim sunumu (30 dk, 14 Eki 2026): /r/temizmama-sunum'dan kısaltılmış ayrı deste,
                tam ekran, sidebar YOK. Temizmama markasına kilitli (allowBrandIds), kaynak src/pages/temizmama-yonetim/. */}
            <Route path="/r/temizmama-yonetim" element={
              <ProtectedRoute allowBrandIds={['675cf508-b160-4767-b75e-43be853e3e59']}>
                <TemizmamaYonetim />
              </ProtectedRoute>
            } />
            {/* Temizmama branding sunumu (14 Eki 2026): bakış açısı + uygulama planı, yönetim destesinin hattından ayrı deste,
                tam ekran, sidebar YOK. Temizmama markasına kilitli (allowBrandIds), kaynak src/pages/temizmama-branding/. */}
            <Route path="/r/temizmama-branding" element={
              <ProtectedRoute allowBrandIds={['675cf508-b160-4767-b75e-43be853e3e59']}>
                <TemizmamaBranding />
              </ProtectedRoute>
            } />
            {/* JujuMood toplantısı: benzer global takı markalarının ana sayfa ve ürün görseli kıyası (6 Eki 2026),
                tam ekran, sidebar YOK. JujuMood markasına kilitli (allowBrandIds), kaynak src/pages/juju-gorsel-kiyas/. */}
            <Route path="/r/juju-gorsel-kiyas" element={
              <ProtectedRoute allowBrandIds={['a431e51f-1154-45f9-9b0b-b07f0f39a80b']}>
                <JujuGorselKiyas />
              </ProtectedRoute>
            } />
            {/* Yataş ekibine yapay zekâ görünürlüğü (GEO) anlatım destesi (2 Eki 2026), tam ekran, sidebar YOK.
                Dört Yataş markasından biri seçiliyken açılır. Kaynak src/pages/yatas-geo-sunum/. */}
            <Route path="/r/yatas-geo-sunum" element={
              <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7', '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', 'dfcf54dd-b00d-434a-be1e-27b6484848eb']}>
                <YatasGeoSunum />
              </ProtectedRoute>
            } />
            {/* Baqa: SEO odaklı tanışma sunumu. Search Console + GA4 bağlı (Efe'nin açtığı baqa hesabı),
                sunum müşteriye PDF olarak gidiyor → e-posta kilidi. Kaynak src/pages/baqa-seo/. */}
            <Route path="/r/baqa-seo" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <BaqaSeo />
              </ProtectedRoute>
            } />
            {/* High5 x On: On global ekibiyle toplantı için veri destesi (24 Eyl 2026), İngilizce, 11 slayt.
                High5 gerçek marka → marka kilidi. Kaynak src/pages/high5-on/; yeniden üretmek için o klasörde build.js. */}
            <Route path="/r/high5-on" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5On />
              </ProtectedRoute>
            } />
            {/* High5 x On etki çalışması: On kendi kanalını açınca High5 etkisi + marka/SKU/yeni marka planı
                (Arzu Hanım talebi, teslim 20 Eki 2026), Türkçe, 18 slayt. High5 marka kilidi.
                Kaynak src/pages/high5-on-etki/ (node build.js), ham analiz ~/high5-on-etki/. */}
            {/* High5 mobil dönüşüm özeti: 6 slayt, Apple tarzı (12 Eki 2026). Ayrıntılısı /r/high5-mobil-donusum.
                Aynı deste public linkte de (HIGH5_MOBIL_DONUSUM_PATH). Kaynak src/pages/high5-mobil-ozet/. */}
            <Route path="/r/high5-mobil-ozet" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5MobilOzet />
              </ProtectedRoute>
            } />
            <Route path="/r/high5-on-etki" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5OnEtki />
              </ProtectedRoute>
            } />
            {/* High5 ASICS indirim dönemi (15–19 Eki 2026): öncesi / indirim / sonrası, harcama, kaynak, ciro,
                beden kırığı, fiyat konumu. Kaynak src/pages/high5-asics-indirim/ (node build.js). */}
            <Route path="/r/high5-asics-indirim" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5AsicsIndirim />
              </ProtectedRoute>
            } />
            {/* High5 Ekim 2026 değerlendirmesi: Eylül kıyaslı, marka bazında. Kaynak src/pages/high5-ekim/ (node build.js). */}
            <Route path="/r/high5-ekim" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5Ekim />
              </ProtectedRoute>
            } />
            {/* High5 On haftalık görünüm: son 12 hafta, 4'er haftalık blok kıyası. Kaynak src/pages/high5-on-haftalik/ (node build.js). */}
            <Route path="/r/high5-on-haftalik" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5OnHaftalik />
              </ProtectedRoute>
            } />
            {/* High5'a: on.com.tr açılışında Glowy-On çalışması için çalışma ilkeleri (21 Eki 2026). Kaynak src/pages/high5-on-calisma-ilkeleri/. */}
            <Route path="/r/high5-on-calisma-ilkeleri" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <High5OnCalismaIlkeleri />
              </ProtectedRoute>
            } />
            <Route path="/r/common-leisure-denetim" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <CommonLeisureDenetim />
              </ProtectedRoute>
            } />
            {/* Yorstruly — tanışma toplantısı için dışarıdan denetim + sektör + glowy
                tanıtımı, 21 slayt (15. Glowy Studio çerçeveleri). Marka platformda kayıtlı değil, e-posta kilidi.
                Kaynak src/pages/yorstruly-denetim/; yeniden üretmek için o klasörde
                build.js sonra pdf.js. */}
            <Route path="/r/yorstruly-denetim" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <YorstrulyDenetim />
              </ProtectedRoute>
            } />
            {/* Yorstruly — performans pazarlaması teklif destesi, 12 slayt (50.000 ₺ + KDV/ay).
                Kaynak /home/glowyadmin/deck-src/yorstruly-teklif; build_deck.py, PDF export_pdf.js + merge_pdf.py. */}
            {/* Yorstruly Kasım 2026 toplantısı: satış, Meta, yapılanlar, yeni setler, Kasım kampanyası, e-posta, stok, kararlar.
                Kaynak src/pages/yorstruly-kasim/ (fetch_*.js, data.py, node build.js). */}
            <Route path="/r/yorstruly-kasim" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com', '@yorstruly.com', 'temur.merve@gmail.com', 'yaseminors@gmail.com']}>
                <YorstrulyKasim />
              </ProtectedRoute>
            } />
            <Route path="/r/yorstruly-teklif" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <YorstrulyTeklif />
              </ProtectedRoute>
            } />
            {/* Under Armour Türkiye — 2027 planı, 14 slayt: ay ay ciro/oturum/CR/sepet,
                kaynak kırılımı, medya bütçesi. Marka platformda kayıtlı değil, veri
                müşterinin gönderdiği dosyalardan (GA4, Google Ads, Meta, RTB, Adjust),
                o yüzden e-posta kilidi. Kaynak src/pages/under-armour-2027/:
                python3 model.py (rakamlar) sonra node build.js (HTML + PDF). */}
            <Route path="/r/under-armour-2027" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <UnderArmour2027 />
              </ProtectedRoute>
            } />
            {/* NNormal — markanın arama talebinin DIŞARIDAN röntgeni, 18 slayt.
                Marka platformda kayıtlı değil (ölçüm tamamen Keyword Planner'dan),
                o yüzden marka kilidi değil e-posta kilidi var.
                Kaynak src/pages/nnormal-arama/; yeniden üretmek için o klasörde
                build.js, ölçümü tazelemek için fetch.py. */}
            <Route path="/r/nnormal-arama" element={
              <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                <NnormalArama />
              </ProtectedRoute>
            } />
            {/* Yataş Grubu — Glowy Studio çerçeve üretimi teklifi. Yataş Bedding,
                Puffy ve Enza Home TEK sunumda, 6 slayt. Kaynak
                src/pages/glowy-studio-teklif/; yeniden üretmek için o klasörde
                build.js sonra pdf.js. */}
            <Route path="/r/glowy-studio-teklif" element={
              <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7', '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e']}>
                <GlowyStudioTeklif />
              </ProtectedRoute>
            } />
            {/* idefix — Glowy Studio çerçeve teklifi, Yataş Grubu teklifinin tek
                markalı uyarlaması. 6 slayt. Kaynak src/pages/idefix-studio-teklif/,
                kareler glowytics-backend/scripts/idefix_studio/render.py. */}
            <Route path="/r/idefix-studio-teklif" element={
              <ProtectedRoute allowBrandIds={['0f9f5fa5-b723-4070-9da3-4b6076c4dbcf', '2ffbdf3d-0011-48c2-9c32-fe699e7e654c', 'f1601139-fc4e-4712-9525-d5b29e753734']}>
                <IdefixStudioTeklif />
              </ProtectedRoute>
            } />
            {/* ASICS (High5) — arama görünürlüğü, ses payı ve iki haftalık bütçe
                senaryoları. 20 slayt, 16:9. Sidebar YOK: müşteri toplantısında tam
                ekran gösteriliyor ve PDF olarak gidiyor. Kaynak
                src/pages/asics-gorunurluk/, üretmek için o klasördeki build.js. */}
            <Route path="/r/asics-gorunurluk" element={
              <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                <AsicsGorunurluk />
              </ProtectedRoute>
            } />
            {/* Yataş Grubu — SAP entegrasyonunda talep edeceğimiz alanların listesi.
                Yataş'ın SAP ve e-ticaret ekiplerine gönderilecek teslimat, PDF olarak
                basılıyor; o yüzden sidebar layout'unun dışında tam ekran belge.
                Kaynak src/pages/yatas-sap-veri/, üretmek için o klasördeki build.js. */}
            <Route path="/r/yatas-sap-veri" element={
              <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7']}>
                <YatasSapVeri />
              </ProtectedRoute>
            } />
            <Route path="/r/gurgencler-yenilio-favicon" element={
              <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82', 'c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                <FaviconSerpReport />
              </ProtectedRoute>
            } />
            {/* Europcar — web geliştirme ekibine gönderilecek dataLayer ölçüm
                spesifikasyonu. Tam ekran belge (PDF olarak basılıyor), o yüzden
                layout dışında; sidebar'da yine de bağlantısı var. */}
            <Route path="/r/europcar-datalayer" element={
              <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                <EuropcarDataLayerSpec />
              </ProtectedRoute>
            } />
            {/* Pinterest format rehberi — Pin, Fikir Pini, Pano, Kolaj. Marka verisi
                yok, giriş yapmış herkes açabilir. Tam ekran belge (PDF olarak basılıyor),
                o yüzden sidebar layout'unun dışında. Kaynak src/pages/pinterest-formatlari/,
                üretmek için o klasördeki build.js. */}
            <Route path="/r/pinterest-formatlari" element={
              <ProtectedRoute requireBrand={false}>
                <PinterestFormatlari />
              </ProtectedRoute>
            } />
            {/* Pinterest reklam rehberi — yerleşim, hedef, format. Yukarıdaki format
                rehberinin kardeşi; ekran görüntülerini onunla ORTAK klasörden çekiyor
                (backend public/pinterest/). Kaynak src/pages/pinterest-ads/. */}
            <Route path="/r/pinterest-ads" element={
              <ProtectedRoute requireBrand={false}>
                <PinterestAds />
              </ProtectedRoute>
            } />
            <Route path="/345435gurgencler" element={
              <ProtectedRoute allowBrandIds={['c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                <YenilioStrategyPlan />
              </ProtectedRoute>
            } />
            
            {/* Brand Selector - giriş yapmamış kullanıcılar erişemez */}
            <Route path="/brand-selector" element={
              <ProtectedRoute requireBrand={false}>
                <BrandSelector />
              </ProtectedRoute>
            } />

            {/* Diğer tüm sayfalar için Sidebar layout'u ve ProtectedRoute kullanalım */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppShell>
                      <Routes>
                        <Route path="/" element={<Overview2 />} />
                        <Route path="/overview" element={<Overview2 />} />
                        <Route path="/overview2" element={<Overview2 />} />
                        {/* v17 — sıfırdan Overview prototipi (v16 çerçevesinde), şimdilik sadece Efe */}
                        <Route path="/overview-v17" element={
                          <ProtectedRoute allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <OverviewV17 />
                          </ProtectedRoute>
                        } />
                        {/* v16 çerçeve denemesi — Overview2 kopyası, şimdilik sadece Efe */}
                        <Route path="/overview-v16" element={
                          <ProtectedRoute allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <OverviewV16 />
                          </ProtectedRoute>
                        } />
                        <Route path="/overviewv5" element={<Overview5 />} />
                        <Route path="/overviewv7" element={<OverviewV7 />} />
                        <Route path="/overviewv21738" element={<Overviewv21738 />} />
                        <Route path="/overviewv9" element={<OverviewV9 />} />
                        <Route path="/overviewv10" element={<OverviewV10 />} />
                        <Route path="/overviewv11" element={<Overviewv11 />} />
                        <Route path="/testingoverview" element={<TestingOverview />} />
                        <Route path="/__lab/testing-overview2" element={<TestingOverview2 />} />
                        <Route path="/lab/testing-overview2" element={<TestingOverview2 />} />
                        <Route path="/custom-report" element={<Navigate to="/custom-report/report-1" replace />} />
                        <Route path="/custom-report/report-1" element={<CustomReport1 />} />
                        <Route path="/custom-report/report-2" element={<CustomReport2 />} />
                        <Route path="/custom-report/report-3" element={<CustomReport3 />} />
                        <Route path="/custom-report/report-4" element={<CustomReport4 />} />
                        <Route path="/custom-report/report-5" element={<CustomReport5 />} />
                        <Route path="/custom-report/report-6" element={<CustomReport6 />} />
                        <Route path="/custom-report/report-7" element={<CustomReport7 />} />
                        <Route path="/faturalama" element={<BillingSpend />} />
                        {/* Genel (markadan bağımsız) harcama faturası. /faturalama Yataş
                            grubunun biçimine göre yazıldı ve öyle kalıyor; burası hiçbir oran
                            varsaymaz, ücret/komisyon marka bazında ayarlanır. */}
                        <Route path="/harcama-faturasi" element={<BillingSpendGeneral />} />
                        {/* HUPALUPA grubu patron paneli — dört marka (Store, Eğlence,
                            Kixx, Keramet) tek şirket, dördü de aynı Business Manager'da.
                            Sayfa gruba bakar, tek markaya değil; allowBrandIds dördünü
                            birden kabul ediyor ki grup içindeki hangi marka seçili olursa
                            olsun açılsın. Asıl yetki kontrolü backend'de
                            (routes/groupPanel.js → VIEWERS). Kixz bu gruba AİT DEĞİL. */}
                        <Route path="/grup/hupalupa" element={
                          <ProtectedRoute allowBrandIds={[
                            'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
                            '9e3c368d-d70d-4ba4-9506-fa0f65b526f7',
                            'd350d46e-fa7e-4aa0-98d6-317aca15c607',
                            'd57a0a98-b47c-45d5-ae2e-ff0fc265f270',
                          ]}>
                            <HupalupaGroup />
                          </ProtectedRoute>
                        } />
                        {/* Aynı grubun FATURALANDIRMA ekranı — harcamayı patron
                            paneliyle aynı uçtan okur (/api/group/hupalupa/monthly),
                            üzerine mecra ücreti + stopaj + KDV + Glowy hakedişi
                            bindirir. Yetki listesi bilerek yukarıdakiyle AYNI:
                            gruba erişen fatura ekranını da görür. */}
                        <Route path="/grup/hupalupa/faturalandirma" element={
                          <ProtectedRoute allowBrandIds={[
                            'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
                            '9e3c368d-d70d-4ba4-9506-fa0f65b526f7',
                            'd350d46e-fa7e-4aa0-98d6-317aca15c607',
                            'd57a0a98-b47c-45d5-ae2e-ff0fc265f270',
                          ]}>
                            <HupalupaGroupBilling />
                          </ProtectedRoute>
                        } />
                        <Route path="/grup/hupalupa/faturalandirma-kopya" element={
                          <ProtectedRoute allowBrandIds={[
                            'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
                            '9e3c368d-d70d-4ba4-9506-fa0f65b526f7',
                            'd350d46e-fa7e-4aa0-98d6-317aca15c607',
                            'd57a0a98-b47c-45d5-ae2e-ff0fc265f270',
                          ]}>
                            <HupalupaGroupBillingKopya />
                          </ProtectedRoute>
                        } />
                        <Route path="/wall" element={<ExecutiveWall />} />
                        <Route path="/weekly-report" element={<WeeklyExecutiveReport />} />
                        <Route path="/pacing" element={<Pacing />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/ads-change-history" element={<AdsChangeHistory />} />
                        <Route path="/meta-ad-inspector" element={<MetaAdInspector />} />
                        {/* Wunder × Birkenstock "Daytripping" — Meta etkileşim
                            kampanyasının kreatif karesi + tam metrik dökümü.
                            Sidebar'lı: panelin İÇİNDE duruyor, ayrı bir belge gibi
                            görünmesin diye tasarımı da panel diline göre yazıldı.
                            Rakamlar statik, kaynak
                            src/pages/wunder-birkenstock-engagement/ (build.js). */}
                        {/* On'un High5'a gönderdiği FW26 "Run On Clouds" B2B rehberinin özeti.
                            Sidebar'lı, High5 marka kilidi. Kaynak src/pages/on-fw26-rehber/ (build.js). */}
                        {/* High5 Meta Ads: /r/high5-on-google-ads'in Meta ikizi (AEM, iki reklam hesabı).
                            Kaynak src/pages/high5-meta-ads/ (build.js + aem.json + query.sql). */}
                        <Route path="/r/high5-meta-ads" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5MetaAds />
                          </ProtectedRoute>
                        } />
                        {/* High5 On Google Ads: bütçe, tıklama, CPC, BQ geliri — aylık + Mart=100 endeksi.
                            Kaynak src/pages/high5-on-google-ads/ (build.js + ads.json + aem.json + query.sql). */}
                        <Route path="/r/high5-on-google-ads" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5OnGoogleAds />
                          </ProtectedRoute>
                        } />
                        {/* High5 GA4 hunisi: ürün görüntüleme → sepet → ödeme → satın alma, kanal × ay.
                            Kaynak src/pages/high5-kanal-hunisi/ (build.js + data.json + query.sql). */}
                        <Route path="/r/high5-kanal-hunisi" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5KanalHunisi />
                          </ProtectedRoute>
                        } />
                        {/* High5 mobil × masaüstü dönüşüm farkı (Eylül 2026, AEM).
                            Kaynak src/pages/high5-mobil-donusum/ (fetch.js → data.json → calc.js + build.js). */}
                        <Route path="/r/high5-mobil-donusum" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5MobilDonusum />
                          </ProtectedRoute>
                        } />
                        {/* High5 yeni kullanıcı / remarketing harcama ayrımı (ad bazlı RM/NU).
                            Kaynak src/pages/high5-rm-dagilimi/ (build.js + data.json). */}
                        <Route path="/r/high5-rm-dagilimi" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5RmDagilimi />
                          </ProtectedRoute>
                        } />
                        {/* High5 kaynak bazlı ciro: Haz–Eyl ay ay + Ağu↔Eyl günlük (AEM).
                            Kaynak src/pages/high5-kaynak-buyume/ (fetch.js → daily.json → build.js). */}
                        <Route path="/r/high5-kaynak-buyume" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5KaynakBuyume />
                          </ProtectedRoute>
                        } />
                        <Route path="/r/on-fw26-rehber" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <OnFw26Rehber />
                          </ProtectedRoute>
                        } />
                        <Route path="/r/wunder-birkenstock-engagement" element={
                          <ProtectedRoute allowBrandIds={['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']}>
                            <WunderBirkenstockEngagement />
                          </ProtectedRoute>
                        } />
                        <Route path="/meta-carousel-cards" element={<MetaCarouselCards />} />
                        <Route path="/labs/kpi-targets" element={<YatasKpiTargets />} />
                        <Route path="/yatas/bulten" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <MonthlyBulletin />
                          </ProtectedRoute>
                        } />
                        {/* Yataş grubu giriş panosu — Overview'a dokunmadan ayrı sayfa (7 Eki 2026) */}
                        <Route path="/yatas/pano" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <PerformancePanel />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/takip" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <DynamicTracking />
                          </ProtectedRoute>
                        } />
                        {/* Kampanya adındaki iş/brief kodları (Eyl26-001 vb.) — 18 Eki 2026 */}
                        <Route path="/yatas/kampanya-kodlari" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <CampaignCodes />
                          </ProtectedRoute>
                        } />
                        {/* GBP × lokal: 7 Eki 2026'da /yatas/planlama sekmesinden ayrıldı, sidebar Business Profile altında */}
                        <Route path="/gbp/lokal" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <YatasLocalPerformance />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/davranis-segmentasyonu" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <YatasDavranisSegmentasyonu />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/davranis-haritasi" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]}>
                            <YatasDavranisHaritasi />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/planlama" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]} denyRoles={['MARKETER']}>
                            <YatasPlanning />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/uyarilar-prototip" element={
                          <ProtectedRoute allowBrandIds={[
                            '44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb',
                            '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
                          ]} denyRoles={['MARKETER']}>
                            <YatasAlertsPrototype />
                          </ProtectedRoute>
                        } />
                        <Route path="/yatas/ai-visibility" element={<YatasAiVisibility />} />
                        <Route path="/ai-visibility" element={<YatasAiVisibility />} />
                        <Route path="/ai-visibility/kaynaklar" element={<AiVisibilitySources />} />
                        <Route path="/ai-visibility/yapilacaklar" element={<AiVisibilityTodo />} />
                        <Route path="/ai-visibility/personalar" element={<AiVisibilityPersonas />} />
                        <Route path="/yatas/frame-studio" element={<YatasFrameStudio />} />
                        <Route path="/glowy-studio" element={<FeedBuilder />} />
                        {/* Çerçeve Atölyesi — ekip içi Claude çerçeve paneli; kilit backend'de (yalnız @heyglowy.com) */}
                        <Route path="/cerceve-atolyesi" element={<CerceveAtolyesi />} />
                        {/* idefix toplu kare üretimi izleme — yalnız Efe (sayfa + backend e-posta kilidi) */}
                        <Route path="/labs/idefix-uretim" element={<IdefixUretim />} />
                        {/* Canlı sitede on-site widget'ları (duyuru/popup/öneri/sepet) kurma —
                            sadece hosgelsin; backend'de de e-posta + marka kilidi var */}
                        {/* Müşteri sitelerindeki form doldurumları (GTM → /api/leads/v1/collect) */}
                        <Route path="/leadler" element={<LeadInbox />} />
                        <Route path="/cro/kaynak-takibi" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']} allowBrandIds={['8a07ce35-0fb3-4019-b0b2-60617b3c1d29']}>
                            <AttributionTracking />
                          </ProtectedRoute>
                        } />
                        {/* GTM kurulum rehberi: her marka için (marka kilidi yok), yalnız iç kullanım; backend'de de e-posta kilidi */}
                        <Route path="/cro/kaynak-takibi/kurulum" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']}>
                            <AttributionSetup />
                          </ProtectedRoute>
                        } />
                        <Route path="/cro/kaynak-takibi/veri" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']} allowBrandIds={['8a07ce35-0fb3-4019-b0b2-60617b3c1d29']}>
                            <AttributionData />
                          </ProtectedRoute>
                        } />
                        <Route path="/cro/widgets" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']} allowBrandIds={['8a07ce35-0fb3-4019-b0b2-60617b3c1d29']}>
                            <WidgetStudio />
                          </ProtectedRoute>
                        } />
                        {/* Glowy Mail — e-posta pazarlama platformu (backend'de de e-posta kilidi) */}
                        <Route path="/email" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']}>
                            <EmailPlatform />
                          </ProtectedRoute>
                        } />
                        {/* Site içi AI sohbet asistanı yönetimi — hosgelsin + e-posta kilidi */}
                        <Route path="/cro/asistan" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com', 'efe@glowytics.com']} allowBrandIds={['8a07ce35-0fb3-4019-b0b2-60617b3c1d29']}>
                            <ChatAssistantStudio />
                          </ProtectedRoute>
                        } />
                        {/* eski rota: kayıtlı yer imleri için duruyor */}
                        <Route path="/cro/pdp-editor" element={<Navigate to="/cro/widgets" replace />} />
                        {/* eski rota: kayıtlı yer imleri ve paylaşılmış linkler için duruyor */}
                        <Route path="/feed-builder" element={<FeedBuilder />} />
                        <Route path="/insights" element={<InsightsFeed />} />
                        <Route path="/sahlanma" element={<SahlanmaCommandCenter />} />
                        <Route path="/egitim/dijital-pazarlama-101" element={<DigitalMarketing101 />} />
                        <Route path="/egitim/consent-mode-v2" element={<ConsentModeV2 />} />
                        {/* Playmobil katalog görüntüleyici — sadece HUPALUPA (strateji/viral deck'leriyle aynı kilit) */}
                        <Route path="/market-insights/playmobil" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <PlaymobilCatalog />
                          </ProtectedRoute>
                        } />
                        {/* Rakip fiyat karşılaştırması — sadece High5 */}
                        <Route path="/high5/price-comparison" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <CompetitorOnComparison />
                          </ProtectedRoute>
                        } />
                        {/* Satıcı × marka fiyat konumu + ürün listesi — sadece High5, menüde yok (direkt URL) */}
                        <Route path="/high5/price-by-seller" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5SellerPriceMatrix />
                          </ProtectedRoute>
                        } />
                        {/* Kixz rakip fiyat karşılaştırması + bizde olmayan ürünler — sadece Kixz */}
                        <Route path="/kixz/price-comparison" element={
                          <ProtectedRoute allowBrandIds={['6e38ac10-35a4-49e3-9f71-d5d08f8ad20c']}>
                            <CompetitorOnComparison />
                          </ProtectedRoute>
                        } />
                        {/* Propia fiyat takibi + rakip muadil ürünler — sadece Propia */}
                        <Route path="/propia/price-tracking" element={
                          <ProtectedRoute allowBrandIds={['e1c18e45-15db-4200-8fca-b150d15ac7aa']}>
                            <PropiaPriceTracking />
                          </ProtectedRoute>
                        } />
                        {/* Skechers rakip fiyat karşılaştırması — sadece Skechers Türkiye */}
                        <Route path="/skechers/price-comparison" element={
                          <ProtectedRoute allowBrandIds={['fbef3c8c-dbb1-4cf0-bbe7-abacb1a76c74']}>
                            <CompetitorOnComparison />
                          </ProtectedRoute>
                        } />
                        {/* Skechers: bizim rakip fiyat taraması × Google MC benchmark yan yana */}
                        <Route path="/skechers/price-vs-benchmark" element={
                          <ProtectedRoute allowBrandIds={['fbef3c8c-dbb1-4cf0-bbe7-abacb1a76c74']}>
                            <PriceBenchmarkVsComparison />
                          </ProtectedRoute>
                        } />
                        {/* Wunder rakip fiyat karşılaştırması — sadece Wunder 2026 */}
                        <Route path="/competitor/wunder-price" element={
                          <ProtectedRoute allowBrandIds={['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']}>
                            <CompetitorOnComparison />
                          </ProtectedRoute>
                        } />
                        {/* VeloRent (demo) rakip günlük kiralama fiyat karşılaştırması */}
                        <Route path="/velorent/price-comparison" element={
                          <ProtectedRoute allowBrandIds={['9cab92ad-1422-4684-9d57-2ef1464338ec']}>
                            <CompetitorOnComparison />
                          </ProtectedRoute>
                        } />
                        {/* Wunder — bir satışın bize maliyeti — sadece Wunder 2026 */}
                        <Route path="/wunder/cost-per-sale" element={
                          <ProtectedRoute allowBrandIds={['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']}>
                            <WunderCostPerSale />
                          </ProtectedRoute>
                        } />
                        <Route path="/ads-platforms/meta-ads/product-spend" element={<MetaProductSpend />} />
                        <Route path="/reports/meta-catalog-product-spend" element={<MetaProductSpend />} />
                        <Route path="/app-overview" element={<AppOverview />} />
                        {/* Ali Bey'e özel yorumlu rapor — sadece Gürgençler + Yenilio brand'leri */}
                        <Route path="/r/zx8m-strateji-haftalik-2026-04" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82', 'c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <WeeklyExecutiveReport />
                          </ProtectedRoute>
                        } />
                        {/* Gürgençler CX geçişi sonrası YoY rapor — sadece Gürgençler */}
                        <Route path="/r/gurgencler-cx-yoy-2026" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                            <GurgenclerCXReport />
                          </ProtectedRoute>
                        } />
                        {/* Gürgençler Temmuz–Eylül dönem raporu — GA4 canlı, sadece Gürgençler */}
                        <Route path="/r/gurgencler-q3" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                            <GurgenclerReport />
                          </ProtectedRoute>
                        } />
                        {/* Gürgençler günlük ham veri seti (Ali Bey talebi) — Excel'in sayfa hâli */}
                        <Route path="/r/gurgencler-gunluk-veri" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                            <GurgenclerRawData />
                          </ProtectedRoute>
                        } />
                        {/* Gürgençler 2026 BTS medya planı — 2025 gerçekleşenden türetilmiş */}
                        <Route path="/r/gurgencler-bts-2026" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                            <GurgenclerBTS2026 />
                          </ProtectedRoute>
                        } />
                        {/* Europcar 21.07.2026 toplantı notları — sadece Europcar */}
                        <Route path="/r/europcar-toplanti-21-07-2026" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarMeetingNotes />
                          </ProtectedRoute>
                        } />
                        {/* Europcar blog içerik envanteri — sadece Europcar */}
                        <Route path="/r/europcar-blog" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarBlogReport />
                          </ProtectedRoute>
                        } />
                        {/* İçerik Stüdyosu — marka sınırlarıyla SEO yazısı üret/arşivle/dışa aktar.
                            Sidebar'a BİLEREK bağlanmadı: adresten açılıyor. Sınırlar ve arşiv
                            marka şemasında, o yüzden marka seçili olmalı (requireBrand). */}
                        <Route path="/icerik/studyo" element={
                          <ProtectedRoute allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'mert@heyglowy.com']}>
                            <ContentStudio />
                          </ProtectedRoute>
                        } />
                        {/* Europcar marka dışı organik arama — sadece Europcar */}
                        <Route path="/r/europcar-nonbrand" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarNonBrandReport />
                          </ProtectedRoute>
                        } />
                        {/* Europcar lokasyon sayfası öncelik listesi — sadece Europcar */}
                        <Route path="/r/europcar-lokasyon" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarLocationPages />
                          </ProtectedRoute>
                        } />
                        {/* Canon Coral (World Unseen) — canlı Meta API, sadece Canon */}
                        <Route path="/r/canon-coral" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralReport />
                          </ProtectedRoute>
                        } />
                        {/* Google Ads dönüşüm kırılımı — kampanya × dönüşüm eylemi (canlı API), seçili marka */}
                        <Route path="/r/google-ads-donusum" element={
                          <ProtectedRoute>
                            <GoogleAdsDonusumKirilimi />
                          </ProtectedRoute>
                        } />
                        {/* Europcar kaynak raporu — kaynak bazında rezervasyon × harcama, sadece Europcar */}
                        <Route path="/r/europcar-kaynak" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarKaynakRaporu />
                          </ProtectedRoute>
                        } />
                        {/* Europcar canlı GA4 ölçüm panosu — sadece Europcar */}
                        <Route path="/r/europcar-ga4" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarGa4Panel />
                          </ProtectedRoute>
                        } />
                        {/* Europcar checkout etiketleme denetimi — "uygulandı" dönüşünü
                            canlı GA4'e sorarak doğrular (gerçek zamanlı + saat kırılımı).
                            Sadece Europcar */}
                        <Route path="/r/europcar-checkout-denetimi" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarCheckoutAudit />
                          </ProtectedRoute>
                        } />
                        {/* Europcar araç arama talebi — GTM arac_arama olayı, canlı GA4. Sadece Europcar */}
                        <Route path="/r/europcar-arama" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarAramaTalebi />
                          </ProtectedRoute>
                        } />
                        {/* Europcar GA4 üye girişi ölçümü — login olayı yok, başlıkla ayrım. Sadece Europcar */}
                        <Route path="/r/europcar-login" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarLoginReport />
                          </ProtectedRoute>
                        } />
                        {/* Europcar & Goldcar Google kayıt adı denetimi — kural seti + ad önerisi. Sadece Europcar */}
                        <Route path="/r/europcar-google-isim" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarGoogleIsimReport />
                          </ProtectedRoute>
                        } />
                        {/* Europcar Google ortalama puanı, Ocak ↔ Ekim 2026. Sadece Europcar */}
                        <Route path="/r/europcar-google-puan" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarGooglePuan />
                          </ProtectedRoute>
                        } />
                        {/* Çift sayılan satın alma dönüşümü + gerçekçi ROAS — sadece BlackSpade */}
                        <Route path="/blackspade/donusum-denetimi" element={
                          <ProtectedRoute allowBrandIds={['3ec08d8c-e9b9-4c83-962f-0871d32edb2c']}>
                            <BlackspadeConversionAudit />
                          </ProtectedRoute>
                        } />
                        {/* Site içi akış haritası (GA4 pageReferrer) — şimdilik sadece Yataş Bedding */}
                        <Route path="/r/yatas-akis" element={
                          <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7']}>
                            <SiteFlowMap />
                          </ProtectedRoute>
                        } />
                        <Route
                          path="/taskboard"
                          element={<TaskBoardWrapper />}
                        />
                        <Route 
                          path="/brands/:brandId/taskboard" 
                          element={<TaskBoardWrapper />} 
                        />
                        
                        {/* Overview Routes */}
                        <Route path="/overview/first" element={<PageTemplate title="Overview - First Page" />} />
                        <Route path="/overview/second" element={<PageTemplate title="Overview - Second Page" />} />
                        
                        {/* Ads Platform Routes */}
                        <Route path="/ads-platforms" element={<AdsOverview />} />
                        <Route path="/ads-platforms/unified-campaigns" element={<UnifiedCampaigns />} />
                        {/* High5-only: ERP net satış Excel yükleme. Sayfa kendi içinde de
                            marka kontrolü yapar, menüde sadece High5'te görünür. */}
                        <Route path="/high5/net-sales" element={<High5NetSalesUpload />} />
                        <Route path="/ads-platforms/google-ads" element={<GoogleAds />} />
                        <Route path="/ads-platforms/meta-overview" element={<MetaOverview />} />
                        <Route path="/ads-platforms/meta-ads" element={<MetaAds />} />
                        <Route path="/ads-platforms/tiktok-ads" element={<TikTokAds />} />
                        <Route path="/ads-platforms/criteo" element={<Criteo />} />
                        <Route path="/ads-platforms/criteo-overview" element={<CriteoOverview />} />
                        <Route path="/ads-platforms/apple-search-ads" element={<AppleSearchAds />} />
                        <Route path="/canon/campaign-report" element={<CanonCampaignReport />} />
                        <Route path="/canon/plan-vs-actual" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonPlanVsActual />
                          </ProtectedRoute>
                        } />
                        <Route path="/canon/cea-report" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCeaReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/canon/canli-rapor" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonLiveNameReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/canon/ccms-raporu-agustos" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCcmsMonthlyReport month="2026-08" />
                          </ProtectedRoute>
                        } />
                        <Route path="/canon/ccms-raporu-eylul" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCcmsMonthlyReport month="2026-09" />
                          </ProtectedRoute>
                        } />
                        <Route path="/canon/megatank-report" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonMegatankReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/ads-platforms/google-ads-test" element={<GoogleAdsTest />} />
                        <Route path="/ads-platforms/meta-ads-2" element={<MetaAds2 />} />
                        <Route path="/ads-platforms/google-ads/overview" element={<GoogleAdsOverview />} />
                        <Route path="/ads-platforms/google-ads/search" element={<SearchCampaigns />} />
                        <Route path="/ads-platforms/google-ads/search-keyword-report" element={<SearchKeywordReport />} />
                        <Route path="/ads-platforms/google-ads/search-keyword-report-v3" element={<SearchKeywordReportV3 />} />
                        <Route path="/ads-platforms/google-ads/ad-copy-report" element={<AdCopyReport />} />
                        <Route path="/ads-platforms/google-ads/ad-copy-report-yenilio" element={
                          <ProtectedRoute allowBrandIds={['c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <AdCopyReportYenilio />
                          </ProtectedRoute>
                        } />
                        <Route path="/ads-platforms/google-ads/display" element={<DisplayCampaigns />} />
                        <Route path="/ads-platforms/google-ads/demand-gen" element={<DemandGen />} />
                        <Route path="/ads-platforms/google-ads/gdn-creatives" element={<GdnCreatives />} />
                        <Route path="/ads-platforms/google-ads/shopping" element={<ShoppingCampaigns />} />
                        <Route path="/ads-platforms/google-ads/pmax" element={<PerformanceMax />} />
                        <Route path="/ads-platforms/google-ads/pmax-assets" element={<PMaxAssetPerformance />} />
                        <Route path="/ads-platforms/google-ads/dsa" element={<DynamicSearch />} />
                        <Route path="/ads-platforms/google-ads/video" element={<VideoCampaigns />} />
                        <Route path="/ads-platforms/google-ads/app" element={<AppCampaigns />} />
                        <Route path="/ads-platforms/google-ads/audience-insights" element={<GoogleAdsAudienceInsights />} />
                        {/* Arama görünürlüğü / ses payı — canlı Google Ads. Sunum hâli /r/asics-gorunurluk. */}
                        <Route path="/ads-platforms/google-ads/visibility" element={<SearchVisibility />} />
                        {/* Aynı sayfanın Kampanya × dönem tablosu, tek başına. */}
                        <Route path="/ads-platforms/google-ads/impression-share" element={<ImpressionShareMatrix />} />
                        {/* Test route (not in sidebar) */}
                        <Route path="/labs/google-ads-audiences" element={<AudiencesTest />} />
                        <Route path="/labs/google-ads-audiences/create" element={<AudienceCreator />} />
                        <Route path="/ads-platforms/meta-ads/creative-performance" element={<MetaCreativePerformance />} />
                        <Route path="/ads-platforms/meta-ads/ab-compare" element={<MetaABCompare />} />
                        <Route path="/ads-platforms/meta-ads/rm-vs-newuser" element={<MetaRmVsNewUser />} />
                        <Route path="/ads-platforms/meta-ads/today-impressions" element={<MetaTodayImpressions />} />
                        <Route path="/ads-platforms/pinterest/creative-performance" element={<PinterestCreativePerformance />} />
                        <Route path="/ads-platforms/tiktok-ads/creative-performance" element={<TikTokCreativePerformance />} />
                        <Route path="/ads-platforms/google-ads/creative-performance" element={<GoogleCreativePerformance />} />
                        <Route path="/why-glowytics" element={<WhyGlowytics />} />
                        <Route path="/ads-platforms/meta-ads/campaign-type" element={<MetaCampaignType />} />
                        <Route path="/ads-platforms/meta-ads/engagement-monitor" element={<MetaEngagementMonitor />} />
                        <Route path="/ads-platforms/tiktok-ads/campaign-type" element={<TikTokCampaignType />} />
                        <Route path="/monthly-targets" element={<MonthlyTargetsDashboard />} />
                        <Route path="/reports/campaign-report" element={<CampaignReport />} />
                        <Route path="/reports/salomon-eylul" element={<SalomonCampaignReport />} />
                        <Route path="/reports/adidas-fw26" element={<AdidasCampaignReport />} />
                        <Route path="/reports/asics-eylul" element={<AsicsCampaignReport />} />
                        <Route path="/reports/meta-go-spend" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <MetaGoSpendReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/hupalupa-go" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaGoReport />
                          </ProtectedRoute>
                        } />
                        {/* Google Haritalar lokasyon + yorum röntgeni — sidebar'da VAR
                            (sadece Hupalupa markası seçiliyken görünür). */}
                        {/* Ana sayfadan hangi listeleme sayfasına gidildiği — CANLI GA4.
                            Sidebar'da BİLEREK YOK (efe 4 Eyl 2026'da çıkarttırdı);
                            sayfaya sadece doğrudan URL ile girilir, tekrar ekleme. */}
                        <Route path="/reports/anasayfa-kategori-akisi" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <AnasayfaKategoriAkisi />
                          </ProtectedRoute>
                        } />
                        {/* idefix × U.S. Polo — 6 çerçeve seçeneği (24 Eyl 2026). Sidebar'lı.
                            Kaynak src/pages/idefix-uspolo-cerceve/, kareler B2 ornek/uspolo/. */}
                        <Route path="/r/idefix-uspolo-cerceve" element={
                          <ProtectedRoute allowBrandIds={['0f9f5fa5-b723-4070-9da3-4b6076c4dbcf', '2ffbdf3d-0011-48c2-9c32-fe699e7e654c', 'f1601139-fc4e-4712-9525-d5b29e753734']}>
                            <IdefixUspoloCerceve />
                          </ProtectedRoute>
                        } />
                        {/* Temizmama konkuru iç hazırlık notu (28 Eyl 2026), sidebar'lı.
                            Kaynak src/pages/temizmama-hazirlik/. */}
                        <Route path="/r/temizmama-hazirlik" element={
                          <ProtectedRoute allowBrandIds={['675cf508-b160-4767-b75e-43be853e3e59']}>
                            <TemizmamaHazirlik />
                          </ProtectedRoute>
                        } />
                        {/* Yataş Bedding GEO sağlık kontrolü (2 Eki 2026). Sidebar'da YOK, doğrudan link.
                            Kaynak src/pages/yatas-bedding-geo/. */}
                        <Route path="/r/yatas-bedding-geo" element={
                          <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7']}>
                            <YatasBeddingGeoReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/r/divanev-lokasyon" element={
                          <ProtectedRoute allowBrandIds={['dfcf54dd-b00d-434a-be1e-27b6484848eb']}>
                            <DivanevLokasyonReport />
                          </ProtectedRoute>
                        } />
                        {/* The Zoo Family reklam raporu — harcama, gösterim, tıklama, dönüşüm, ROAS + GA4 satış; sadece HUPALUPA Store */}
                        <Route path="/r/hupalupa-zoo-family" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaZooFamilyRaporu />
                          </ProtectedRoute>
                        } />
                        {/* Aynı raporun İngilizce kopyası — global Zoo Family ekibi için */}
                        <Route path="/r/hupalupa-zoo-family-en" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaZooFamilyReportEn />
                          </ProtectedRoute>
                        } />
                        {/* Website + pazaryeri satışları — mağazanın sales-by-channel CSV'si, sayfadan yüklenir; sadece HUPALUPA Store */}
                        <Route path="/r/hupalupa-kanal-satislari" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaKanalSatis />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/hupalupa-lokasyon" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaLokasyonReport />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/hupalupa-marka-stok" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaBrandStock />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/hupalupa-go-sunum" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaGoPresentation />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/playmobil-strateji" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <PlaymobilStrateji />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/playmobil-viral" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <PlaymobilViral />
                          </ProtectedRoute>
                        } />
                        <Route path="/reports/fitness-seasonality" element={
                          <ProtectedRoute>
                            <FitnessSeasonality />
                          </ProtectedRoute>
                        } />
                        <Route path="/meta/meta-audiences" element={<MetaAudiences />} />
                        <Route path="/meta/kitle-onerileri" element={
                          <ProtectedRoute allowEmails={['@glowytics.com', '@heyglowy.com']}>
                            <AudienceSuggestions />
                          </ProtectedRoute>
                        } />
                        <Route path="/meta/meta-audience-insights" element={<MetaAudienceInsights />} />
                        <Route path="/labs/meta-creative-test" element={<MetaCreativeTest />} />
                        <Route path="/labs/tiktok-ads-test" element={<TiktokAdsTest />} />
                        <Route path="/labs/apple-search-ads-test" element={<AppleSearchAdsTest />} />

                        
                        {/* Campaigns Routes */}
                        <Route path="/campaigns/first" element={<PageTemplate title="Campaigns - First Page" />} />
                        <Route path="/campaigns/second" element={<PageTemplate title="Campaigns - Second Page" />} />
                        
                        {/* Analytics Routes */}
                        <Route path="/analytics/first" element={<PageTemplate title="Analytics - First Page" />} />
                        <Route path="/analytics/second" element={<PageTemplate title="Analytics - Second Page" />} />
                        <Route path="/analytics/analytics-overview" element={<AnalyticsOverview />} />
                        <Route path="/analytics/ga4-overview" element={<GA4Overview />} />
                        <Route path="/analytics/ga4-custom-dimensions" element={<GA4CustomDimensions />} />
                        <Route path="/analytics/ga4-audience" element={<GA4Audience />} />
                        <Route path="/analytics/daily-traffic" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82', 'c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <DailyTraffic />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/page-source-medium-live" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82']}>
                            <PageSourceMediumLive />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/new-vs-returning-revenue" element={<NewVsReturningRevenue />} />
                        <Route path="/analytics/session-engagement" element={<SessionEngagement />} />
                        <Route path="/analytics/hourly-order-analysis" element={<HourlyOrderAnalysis />} />
                        {/* Session → ATC → Checkout → Sipariş gün gün; tüm markalar (BQ varsa BQ, yoksa GA4 Data API) */}
                        <Route path="/analytics/daily-funnel" element={<DailyFunnel />} />
                        <Route path="/analytics/weekday-order-analysis" element={<WeekdayOrderAnalysis />} />
                        {/* Müşteri LTV / tekrar satın alma — GA4 BQ user_id — sadece High5 */}
                        <Route path="/high5/ltv" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5Ltv />
                          </ProtectedRoute>
                        } />
                        {/* High5 Google SKU feed — beden dağılımı — sadece High5 */}
                        <Route path="/high5/size-coverage" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5SkuSizeCoverage />
                          </ProtectedRoute>
                        } />
                        {/* Aylık planın gün gün hedef/gerçekleşen takibi — sadece High5 */}
                        <Route path="/high5/hedef-takip" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5DailyTargetTracking />
                          </ProtectedRoute>
                        } />
                        {/* Yaratıcı + metin performansı; marka bağımsız (Meta yaratıcıları + Google metin varlıkları) */}
                        <Route path="/analytics/creative-insights" element={
                          <ProtectedRoute>
                            <CreativeInsights />
                          </ProtectedRoute>
                        } />
                        {/* Marka aranma hacmi ↔ marka arama kampanyası kapsaması — sadece High5 */}
                        <Route path="/high5/marka-kapsama" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5BrandSearchCoverage />
                          </ProtectedRoute>
                        } />
                        {/* Ay içi ciro hedefi + önceki aya kıyas; STATİK veri (müşteri Excel'i) — sadece High5 */}
                        <Route path="/high5/mtd-hedef" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5MtdTarget />
                          </ProtectedRoute>
                        } />
                        {/* Haftalık Total/UnPaid/Paid KPI tablosu (müşterinin Excel'inin otomatiği) — sadece High5 */}
                        <Route path="/high5/haftalik-kpi" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5WeeklyKpi />
                          </ProtectedRoute>
                        } />
                        {/* Ajansın pazartesi haftalık mailinin veriden üretilen taslağı — sadece High5.
                          * 🔴 SIDEBAR'A EKLENMEDİ (Efe, 21 Eyl 2026); adresi bilen açar. */}
                        <Route path="/high5/haftalik-mail" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5WeeklyMail />
                          </ProtectedRoute>
                        } />
                        {/* Marka arama kampanyalarında rakip rafı + gösterim payı — sadece High5 */}
                        <Route path="/high5/acik-artirma" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5AuctionInsights />
                          </ProtectedRoute>
                        } />
                        {/* Kaynak (hebiar) ↔ reklam (crwizard) feed farkı — sadece High5 */}
                        <Route path="/high5/feed-farki" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5FeedCompare />
                          </ProtectedRoute>
                        } />
                        {/* Marka bazlı günlük + anlık ciro/harcama. Sayfa markadan
                          * bağımsız: High5'te varsayılan ASICS (ciro BigQuery export'undan),
                          * HUPALUPA Store'da NeeDoh (ciro GA4 Data API'sinden).
                          *
                          * 🔑🔑 AYNI SAYFA, İKİ YOL — bilerek. `/high5/marka-canli`
                          * patrona verilmiş bir adres (Efe, 7 Eyl 2026: "high5 inkine
                          * dokunma, patrona verdik, kafası karışmasın"), o yüzden
                          * yönlendirilmiyor bile — olduğu gibi çalışıyor.
                          * `/marka-canli` HUPALUPA için: onun panelinde başka markanın
                          * adını taşıyan URL olmaz. Sidebar hangi markadaysa onu veriyor. */}
                        <Route path="/high5/marka-canli" element={
                          <ProtectedRoute allowBrandIds={[
                            'b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8',
                            'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
                          ]}>
                            <BrandLiveTracker />
                          </ProtectedRoute>
                        } />
                        <Route path="/marka-canli" element={
                          <ProtectedRoute allowBrandIds={[
                            'b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8',
                            'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
                          ]}>
                            <BrandLiveTracker />
                          </ProtectedRoute>
                        } />
                        {/* Merchant Center birikimli beden dökümü — sadece High5 */}
                        <Route path="/high5/beden-birikimi" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5McSizeAccumulation />
                          </ProtectedRoute>
                        } />
                        {/* Ürün bazlı günlük ciro + stok (olan beden) — sadece High5 */}
                        <Route path="/high5/ciro-stok" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5ProductRevenueStock />
                          </ProtectedRoute>
                        } />
                        {/* Günlük fiyat rekabeti (MC benchmark) — sadece High5 */}
                        <Route path="/high5/fiyat-rekabeti" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5PriceCompetitivenessDaily />
                          </ProtectedRoute>
                        } />
                        {/* Haftalık beden kırığı — marka × kategori, sadece High5 */}
                        <Route path="/high5/beden-kirigi" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5SizeBreakageWeekly />
                          </ProtectedRoute>
                        } />
                        {/* En çok satan ürünlerin bugünkü beden durumu — sadece High5 */}
                        <Route path="/high5/satan-beden" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5TopSellerSizeStatus />
                          </ProtectedRoute>
                        } />
                        {/* Ürün bazında haftalık / aylık satış (görsel + ad) — sadece High5 */}
                        <Route path="/high5/urun-satislari" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5ProductSalesPeriods />
                          </ProtectedRoute>
                        } />
                        {/* Dün: ürün x kanal x marka/cinsiyet/beden günlük satış — sadece High5 */}
                        <Route path="/high5/yesterday" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5Yesterday />
                          </ProtectedRoute>
                        } />
                        {/* Koton GA4 360 iş gerekçesi — sadece Koton */}
                        <Route path="/koton/ga4-360" element={
                          <ProtectedRoute allowBrandIds={['062be473-3b2b-4bad-a2e3-a31995e02d57']}>
                            <KotonGa4Business />
                          </ProtectedRoute>
                        } />
                        {/* Grace Brands ürün kataloğu — sadece Grace Brands */}
                        <Route path="/grace/catalog" element={
                          <ProtectedRoute allowBrandIds={['29072fbc-294f-49f1-bb0b-6868f7e54d41']}>
                            <GraceCatalog />
                          </ProtectedRoute>
                        } />
                        {/* Paulmark ürün kataloğu — sadece Paulmark */}
                        <Route path="/paulmark/catalog" element={
                          <ProtectedRoute allowBrandIds={['8591f281-715d-4a80-83cf-59bfb59f6ef3']}>
                            <PaulmarkCatalog />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/adjust-overview" element={<AdjustOverview />} />
                        <Route path="/analytics/source-medium" element={<SourceMedium />} />
                        <Route path="/analytics/source-medium-monthly" element={<SourceMediumMonthly />} />
                        <Route path="/analytics/adjust-source-medium-monthly" element={<AdjustSourceMediumMonthly />} />
                        <Route path="/analytics/combined-traffic-sources" element={<CombinedTrafficSources />} />
                        <Route path="/analytics/product-performance" element={
                          <ProtectedRoute>
                            <ProductPerformance />
                          </ProtectedRoute>
                        } />
                        {/* GA4 oturum kampanyası × satılan ürün — marka bağımsız, canlı GA4. */}
                        <Route path="/analytics/kampanya-urun-satis" element={
                          <ProtectedRoute>
                            <KampanyaUrunSatis />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/product-portfolio-analysis" element={
                          <ProtectedRoute>
                            <ProductPortfolioAnalysis />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/product-portfolio-analysis-2" element={
                          <ProtectedRoute>
                            <ProductPortfolioAnalysis2 />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/channel-mix-reallocation-demo" element={<ChannelMixReallocationDemo />} />
                        <Route path="/analytics/price-elasticity-of-demand" element={<PriceElasticityOfDemand />} />
                        <Route path="/analytics/seasonality-forecast-demo" element={<SeasonalityForecastDemo />} />
                        <Route path="/analytics/rfm-lifecycle-demo" element={<RfmLifecycleDemo />} />
                        <Route path="/analytics/retention-drivers-demo" element={<RetentionDriversDemo />} />
                        <Route path="/analytics/audience-segmentation-demo" element={<AudienceSegmentationDemo />} />
                        <Route path="/analytics/mmm-demo" element={<MMMDemo />} />
                        <Route path="/analytics/period-analysis" element={<PeriodAnalysis />} />
                        <Route path="/analytics/funnel" element={
                          <ProtectedRoute>
                            <Funnel />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/conversion-paths" element={<PageTemplate title="Analytics - Conversion Paths" />} />
                        <Route path="/analytics/revenue-forecasting" element={<RevenueForcasting />} />
                        <Route path="/analytics/internal-search-terms" element={<InternalSearchTerms />} />
                        
                        {/* Budget Routes */}
                        <Route path="/budget/branding-forecast5435234" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']}>
                            <BrandingForecast />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/branding-forecast3453534" element={<BrandingForecastSWOT3453534 />} />
                        <Route path="/budget/canon-nisan-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonApril2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-beyond-the-frame" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonBeyondFrame2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-temmuz-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonJuly2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCorals2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="haziran" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-temmuz-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="temmuz" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-agustos-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="agustos" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-eylul-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="eylul" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-2026-tum-aylar" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsAll />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-ekim-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="ekim" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-kasim-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="kasim" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-corals-aralik-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCoralsMonthly month="aralik" />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-pv-eylul-indirim" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonPVEylul2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-lens-trade-in-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonLensTradeIn2026 />
                          </ProtectedRoute>
                        } />
                        {/* Europcar programatik ağırlıklı medya planı — sadece Europcar */}
                        <Route path="/budget/europcar-programatik-2026" element={
                          <ProtectedRoute allowBrandIds={['13b58e06-8266-4a5b-8113-2de43aa686e1']}>
                            <EuropcarProgramatik2026 />
                          </ProtectedRoute>
                        } />
                        {/* Kixz teknik SEO & organik büyüme planı — sadece Kixz */}
                        <Route path="/r/kixz-seo-plani" element={
                          <ProtectedRoute allowBrandIds={['6e38ac10-35a4-49e3-9f71-d5d08f8ad20c']}>
                            <KixzSeo2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-back-to-school-2026" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonBackToSchool2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-ccms-icerik" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCCMSContentPlan />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-ccms-icerik-temmuz" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCCMSContentPlanJuly />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-ccms-icerik-agustos" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCCMSContentPlanAugust />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-ccms-icerik-eylul" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonCCMSContentPlanSeptember />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/canon-beyond-the-frame-icerik" element={
                          <ProtectedRoute allowBrandIds={['3987361f-4006-4819-bd83-f78b5a2155ec']}>
                            <CanonBeyondFrameContent />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/high5-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5Haziran2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/analytics/high5-cross-marketing" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5CrossMarketing />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/43058209r8hupalupa" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <BrandingForecast43058209 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-nisan-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaNisan2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-mayis-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9']}>
                            <HupalupaMayis2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaHaziran2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-store-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreHaziran2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-eglence-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaEglenceHaziran2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-agustos-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaAgustos2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-store-agustos-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreAgustos2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-eglence-agustos-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaEglenceAgustos2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/kixx-agustos-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7', 'd350d46e-fa7e-4aa0-98d6-317aca15c607']}>
                            <KixxAgustos2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/keramet-ilicasi-agustos-2026" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <KerametIlicasiAgustos2026 />
                          </ProtectedRoute>
                        } />
                        {/* ── Eylül 2026 medya planları — dördü de ÜÇER slayt, bütçeyi biz öneriyoruz ──
                            Ağustos sayfalarından farkı: bütçe müşteriden gelmedi. Her sunum aynı üç adım:
                            talep (Keyword Planner Ağu→Eyl, iki yıl) → kanıt (markanın kendi canlı verisi)
                            → talep/öneri. Kixx'te bilinçli bir ARTIŞ talebi var (₺59.219 → ₺150.000);
                            Eğlence ve Keramet'te talep gerçekten düştüğü için AZALTMA öneriliyor ve
                            serbest kalan bütçe Kixx'i finanse ediyor. Sidebar'a eklenmedi (Ağustos deseni). */}
                        <Route path="/budget/hupalupa-store-eylul-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreEylul2026 />
                          </ProtectedRoute>
                        } />
                        {/* Ağustos deseninde TAM medya planı — yukarıdaki 3 slaytlık bütçe önerisinden ayrı.
                            Farkı: Store'un genel bütçesi (₺400K) ile içindeki altı markanın bütçesi AYRI
                            yönetiliyor (NeeDoh ₺600K · Playmobil ₺150K · Charm It ₺50K · X Mud ₺40K ·
                            Antonio Juan ₺40K · Zoo Family ₺30K). Sidebar'a eklenmedi, doğrudan link. */}
                        <Route path="/budget/hupalupa-store-eylul-2026-medya-plani" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreEylul2026MedyaPlani />
                          </ProtectedRoute>
                        } />
                        {/* Aynı ayın İKİNCİ planı: bütçe MARKANIN verdiği gibi (₺1.215.000, on bir
                            marka kalemi + ₺150K esnek), kanal dağılımı BİZİM. Yukarıdaki sayfanın yerine
                            geçmez, yanında durur — ikisinin kıyası sunumun kendisi. Sidebar'a eklenmedi. */}
                        <Route path="/budget/hupalupa-store-eylul-2026-marka-butcesi" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreEylul2026MarkaButcesi />
                          </ProtectedRoute>
                        } />
                        {/* Ekim 2026 marka bütçesi: toplam markadan (₺500.000), marka ve kanal dağılımı
                            bizim. Eylül gerçekleşeni donmuş. Sidebar'a eklenmedi. */}
                        <Route path="/budget/hupalupa-store-ekim-2026-marka-butcesi" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaStoreEkim2026MarkaButcesi />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-eglence-eylul-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaEglenceEylul2026 />
                          </ProtectedRoute>
                        } />
                        {/* Ağustos deseninde TAM medya planı, ₺300.000. Slayt sürümü ₺250.000 öneriyordu;
                            bütçe Efe'nin kararıyla Ağustos kapanışına (₺289.724) sabitlendi. */}
                        <Route path="/budget/hupalupa-eglence-eylul-2026-medya-plani" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaEglenceEylul2026MedyaPlani />
                          </ProtectedRoute>
                        } />
                        {/* Hupalupa/KIXX Eylül deseninde TAM medya planı, ₺75.000.
                            Fatmagül Hanım'ın 2 Eylül tarihli bütçe dağılımı talebine yanıt.
                            GANNI lansmanı 14 Eylül, stok 20 Eylül — aradaki altı gün planın
                            kritik yeri. Sidebar'a eklenmedi, doğrudan link. */}
                        <Route path="/budget/hunter-eylul-2026-medya-plani" element={
                          <ProtectedRoute allowBrandIds={['cb2906a7-56fd-4ced-a2b4-1372c958bbea']}>
                            <HunterEylul2026MedyaPlani />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/kixx-eylul-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7', 'd350d46e-fa7e-4aa0-98d6-317aca15c607']}>
                            <KixxEylul2026 />
                          </ProtectedRoute>
                        } />
                        {/* Ağustos deseninde TAM medya planı. Yukarıdaki 3 slaytlık talep onaylanırsa
                            ₺150.000'in kampanya kampanya nereye gittiğini gösterir; ekip/uygulama belgesi.
                            Sidebar'a eklenmedi, doğrudan link. */}
                        <Route path="/budget/kixx-eylul-2026-medya-plani" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7', 'd350d46e-fa7e-4aa0-98d6-317aca15c607']}>
                            <KixxEylul2026MedyaPlani />
                          </ProtectedRoute>
                        } />
                        {/* Glowy Lens (Custom Reports) — kullanıcının kurduğu widget/grafik/pivot sayfaları.
                            Efe her markada; ayrıca dört Yataş markasından biri seçiliyken o markaya
                            erişimi olan herkes doğrudan linkle açar. Sidebar'da yalnız Efe görür. */}
                        <Route path="/custom-reports" element={
                          <GlowyLensRoute>
                            <CustomReports />
                          </GlowyLensRoute>
                        } />
                        <Route path="/custom-reports/:reportId" element={
                          <GlowyLensRoute>
                            <CustomReports />
                          </GlowyLensRoute>
                        } />
                        {/* Keramet `Brand` tablosunda YOK → allowBrandIds çalışmaz, e-posta kilidi. */}
                        <Route path="/budget/keramet-ilicasi-eylul-2026" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <KerametIlicasiEylul2026 />
                          </ProtectedRoute>
                        } />
                        {/* Ağustos deseninde TAM medya planı, ₺70.000 (slayt ₺120.000 öneriyordu).
                            Kardeş rota gibi e-posta kilidi kullanır. */}
                        <Route path="/budget/keramet-ilicasi-eylul-2026-medya-plani" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <KerametIlicasiEylul2026MedyaPlani />
                          </ProtectedRoute>
                        } />
                        {/* Dört Eylül planının TEK ekranda durumu — "plan be plan neredeyiz".
                            Planların yerine geçmez, üstlerinde durur ve her satırdan kendi planına
                            link verir. Plan rakamları dört plan sayfasından import edilir, burada
                            ikinci bir kopya tutulmaz. Gerçekleşen `/api/group/hupalupa/gerceklesen`
                            ucundan canlı; o uç yetkiyi grup domainine göre verdiği için Keramet
                            `Brand` tablosunda olmasa da rakamı gelir.
                            Sidebar'a eklenmedi, doğrudan link (Ağustos/Eylül deseni). */}
                        <Route path="/budget/hupalupa-eylul-2026-durum" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7', 'd350d46e-fa7e-4aa0-98d6-317aca15c607']}>
                            <HupalupaEylulDurum />
                          </ProtectedRoute>
                        } />
                        {/* Medya Planı Stüdyosu — brief → Gemini → düzenlenebilir plan. Marka bağımsız araç. */}
                        {/* Common Leisure Video Stüdyosu — ürün görsellerinden Instagram
                            videosu. Marka `Brand` tablosunda YOK, katalog doğrudan
                            mağazadan okunuyor → e-posta kilidi. Üretim
                            glowytics-backend/scripts/cl_video/render.py. */}
                        <Route path="/common-leisure/video" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'access@heyglowy.com']}>
                            <CommonLeisureVideo />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/plan-studyo" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com']}>
                            <MediaPlanStudio />
                          </ProtectedRoute>
                        } />
                        {/* Instagram Stüdyosu — Glowytics'in KENDİ hesabına yayın. Marka bağımsız
                            iç araç; buradaki e-posta kilidi kozmetik, asıl kilit
                            backend'de (routes/instagram.js → IZINLI_EPOSTALAR). */}
                        {/* Marka Talepleri — müşteri maillerinden bekleyen işler. Kilit backend'de
                            (routes/markaTalepleri.js → IZINLI_EPOSTALAR), buradaki kozmetik. */}
                        {/* Hesap Sağlığı — GlowyAI sağlık kontrolü (Google Ads + Meta, salt okuma).
                            Efe + @yatas.com.tr + @digitalhouse.com.tr (yalnız Yataş markaları); asıl kilit backend'de (routes/healthCheck.js). */}
                        <Route path="/glowyai/health-check" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com', 'efe@glowytics.com', '@yatas.com.tr', '@digitalhouse.com.tr']}>
                            <HealthCheck />
                          </ProtectedRoute>
                        } />
                        <Route path="/wunder/planlar" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com', 'efe@glowytics.com']}>
                            <WunderPlanTakip />
                          </ProtectedRoute>
                        } />
                        <Route path="/kampanya-soylemleri" element={
                          <ProtectedRoute allowBrandIds={['44e35dfe-0186-495d-a0cc-db5e7e459ab7', '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e']} denyRoles={['MARKETER', 'FINANCE', 'GBP']}>
                            <CampaignThemes />
                          </ProtectedRoute>
                        } />
                        <Route path="/talepler" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <MarkaTalepleri />
                          </ProtectedRoute>
                        } />
                        {/* Kullanıcı Takibi — giriş + sayfa hareketleri. Kilit backend'de
                            (routes/kullaniciTakip.js → IZINLI_EPOSTALAR), buradaki kozmetik. */}
                        {/* Kumbara — Glowy gelir/gider özeti (Paraşüt). Menüde yok, kilit backend'de (routes/kz49.js). */}
                        <Route path="/kumbara-zeplin-49" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <Kumbara />
                          </ProtectedRoute>
                        } />
                        <Route path="/kullanici-takip" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <KullaniciTakip />
                          </ProtectedRoute>
                        } />
                        <Route path="/yeni-kullanicilar" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <YeniKullanicilar />
                          </ProtectedRoute>
                        } />
                        <Route path="/yeni-markalar" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <YeniMarkalar />
                          </ProtectedRoute>
                        } />
                        {/* LinkedIn Stüdyosu — iç ekip. Kilit backend'de (routes/linkedinStudyo.js → IC_ALAN). */}
                        <Route path="/linkedin-studyo" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['@glowytics.com', '@heyglowy.com']}>
                            <LinkedInStudyo />
                          </ProtectedRoute>
                        } />
                        <Route path="/social/instagram" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@heyglowy.com']}>
                            <InstagramStudio />
                          </ProtectedRoute>
                        } />
                        {/* Salomon × Wunder iş birliği teklifi — sadece Wunder 2026 */}
                        <Route path="/budget/salomon-wunder-eylul-kasim-2026" element={
                          <ProtectedRoute allowBrandIds={['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']}>
                            <SalomonWunderEylulKasim2026 />
                          </ProtectedRoute>
                        } />
                        {/* Birkenstock × Wunder iş birliği teklifi — sadece Wunder 2026 */}
                        <Route path="/budget/birkenstock-wunder-ekim-aralik-2026" element={
                          <ProtectedRoute allowBrandIds={['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']}>
                            <BirkenstockWunderEkimAralik2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/kixx-haziran-2026" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <KixxHaziran2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/hupalupa-go-kalamis-festivali" element={
                          <ProtectedRoute allowBrandIds={['cb6bbe2d-a3cd-4322-a4e4-2373d10225a9', '9e3c368d-d70d-4ba4-9506-fa0f65b526f7']}>
                            <HupalupaGoKalamisFestival />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/yenilio-mart2026" element={
                          <ProtectedRoute allowBrandIds={['c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <BrandingForecastYenilio />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/branding-plan-jakamen" element={<BrandingPlanJakamen />} />
                        <Route path="/budget/jakamen-branding-250k" element={<BrandingPlanJakamen250K />} />
                        <Route path="/budget/jakamen-dunya-kupasi" element={<BrandingPlanJakamenWorldCup />} />
                        <Route path="/budget/branding-plan-high5" element={<BrandingPlanHigh5 />} />
                        <Route path="/reports/high5-campaign-monthly-live" element={
                          <ProtectedRoute allowBrandIds={['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8']}>
                            <High5CampaignMonthlyLive />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/branding-plan-regalien" element={
                          <ProtectedRoute allowEmails={['efe@heyglowy.com']}>
                            <BrandingPlanRegalien />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/marketing-reports" element={<MarketingReports />} />
                        <Route path="/budget/gurgenciler-q1-2026" element={
                          <ProtectedRoute allowBrandIds={['c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <GurgencilerQ12026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/gurgenciler-dunya-kupasi-2026" element={
                          <ProtectedRoute allowBrandIds={['526a6404-f685-44cd-b57f-27d692845b82', 'c7778265-8ac6-4697-ae89-2f4da315d0ac']}>
                            <GurgencilerDunyaKupasi2026 />
                          </ProtectedRoute>
                        } />
                        <Route path="/budget/forecasting" element={<Forecasting />} />
                        <Route path="/budget/media-planning-table" element={<MediaPlanningTable />} />
                        <Route path="/budget/media-plan-table" element={<MediaPlanTable />} />
                        <Route path="/budget/simple-branding-forecast" element={<SimpleBrandingForecast />} />
                        
                        {/* Goals Routes */}
                        <Route path="/goals/first" element={<PageTemplate title="Goals - First Page" />} />
                        <Route path="/goals/second" element={<PageTemplate title="Goals - Second Page" />} />
                        
                        {/* Predictive Analytics Routes */}
                        <Route path="/predictive/first" element={<PageTemplate title="Predictive Analytics - First Page" />} />
                        <Route path="/predictive/second" element={<PageTemplate title="Predictive Analytics - Second Page" />} />
                        
                        {/* Competitors Routes */}
                        <Route path="/competitors/first" element={<PageTemplate title="Competitors - First Page" />} />
                        <Route path="/competitors/second" element={<PageTemplate title="Competitors - Second Page" />} />
                        <Route path="/market-insights/ads-library" element={<AdsLibrary />} />
                        <Route path="/market-insights/search-volume" element={<SearchVolume />} />
                        <Route path="/market-insights/search-volume-matrix" element={<SearchVolumeMatrix />} />
                        <Route path="/market-insights/high5-search-research" element={<High5SearchResearch />} />
                        <Route path="/market-insights/google-trends" element={<GoogleTrends />} />
                        <Route path="/market-insights/keyword-discover" element={<KeywordDiscover />} />
                                <Route path="/market-insights/youtube-radar" element={<YouTubeTrends />} />
                        <Route path="/market-insights/instagram-radar" element={<InstagramRadar />} />
                        <Route path="/market-insights/instagram-comments" element={<InstagramComments />} />
                        <Route path="/market-insights/instagram-search" element={<InstagramSearchLab />} />
                        <Route path="/market-insights/tiktok-radar" element={<TiktokRadarLab />} />
                        <Route path="/market-insights/app-radar" element={<AppRadar />} />
                        {/* MultiPay yorum analizi — sadece Multinet */}
                        <Route path="/market-insights/multipay-yorum-analizi" element={
                          <ProtectedRoute allowBrandIds={['7f97784c-d406-4400-830b-8d13a7c21d5f']}>
                            <MultipayReviewAnalysis />
                          </ProtectedRoute>
                        } />
                        <Route path="/market-insights/facebook-ads-library" element={<FacebookAdsLibraryRapidLab />} />
                        <Route path="/market-insights/ad-shelf-share" element={<AdShelfShare />} />
                        <Route path="/market-insights/facebook-ads-library-rapid" element={<Navigate to="/market-insights/facebook-ads-library" replace />} />
                        <Route path="/market-insights/google-ads-transparency" element={<GoogleAdsTransparencyRapidLab />} />
                        <Route path="/market-insights/google-ads-transparency-rapid" element={<Navigate to="/market-insights/google-ads-transparency" replace />} />
                        <Route path="/market-insights/youtube-trends" element={<YouTubePopularity />} />
                        {/* Sidebar'da yok — doğrudan URL ile açılır (iç kullanım) */}
                        <Route path="/market-insights/youtube-ai" element={<YouTubeAIResearch />} />
                        <Route path="/market-insights/rtbhouse-connect" element={<RtbHouseConnect />} />
                        <Route path="/market-insights/pinterest-test" element={<PinterestTest />} />
                        <Route path="/pinterest-dashboard" element={<PinterestDashboard />} />
                        <Route path="/market-insights/merchant-insights" element={<MerchantInsights />} />
                        <Route path="/market-insights/merchantinsights" element={<MerchantInsights2 />} />
                        <Route path="/market-insights/merchant-insights2" element={<Navigate to="/market-insights/merchantinsights" replace />} />
                        <Route path="/market-insights/merchant-price-insights2" element={<MerchantPriceInsights2 />} />
                        <Route path="/market-insights/category-seasonality" element={<CategorySeasonality />} />
                        <Route path="/search-console/overview" element={<SearchConsoleOverview />} />
                        <Route path="/search-console/monthly-queries" element={<MonthlyQueries />} />
                        <Route path="/search-console/blog-seo" element={<BlogSeo />} />
                        <Route path="/labs/ads-transparency" element={<AdsTransparencyTest />} />
                        <Route path="/labs/meta-ad-library" element={<MetaAdLibraryLab />} />
                        <Route path="/labs/google-ads-campaigns" element={<GoogleAdsCampaignsLab />} />
                        <Route path="/labs/meta-ads-campaigns" element={<MetaAdsCampaignsLab />} />
                        <Route path="/labs/meta-catalog-creator" element={<MetaCatalogAdsLab />} />
                        <Route path="/labs/banner-heatmap" element={<BannerClickHeatmap />} />
                        <Route path="/labs/meta-media-library" element={<MetaMediaLibraryLab />} />
                        <Route path="/labs/meta-ai-enhancer" element={<MetaAIEnhancerLab />} />
                        <Route path="/labs/meta-image-campaign" element={<MetaImageCampaignLab />} />
                        <Route path="/labs/meta-instagram-debug" element={<MetaInstagramDebug />} />
                        <Route path="/labs/meta-pages" element={<MetaPagesLab />} />
                        <Route path="/labs/merchant-ai-studio" element={<MerchantAIStudioLab />} />
                        <Route path="/labs/google-trends" element={<GoogleTrendsTest />} />
                        <Route path="/labs/google-trends-categories" element={<GoogleTrendsCategoryTest />} />
                        <Route path="/labs/influencer-probe" element={<InfluencerProbe />} />
                        <Route path="/meta-catalog/sets" element={<MetaCatalogTest />} />
                        <Route path="/meta-catalog/products-sets" element={<MetaCatalogProducts />} />
                        <Route path="/meta-catalog/products" element={<Navigate to="/meta-catalog/products-sets" replace />} />
                        <Route path="/labs/meta-catalog-sets" element={<Navigate to="/meta-catalog/sets" replace />} />
                        <Route path="/labs/meta-catalog-test" element={<Navigate to="/meta-catalog/sets" replace />} />
                        <Route path="/meta-catalog-test" element={<Navigate to="/meta-catalog/sets" replace />} />
                        <Route path="/labs/adjust-test" element={<AdjustTest />} />
                        <Route path="/labs/adjust-attribution-compare" element={<AdjustAttributionCompare />} />
                        <Route path="/labs/keyword-planner" element={<KeywordPlannerTest />} />
                        <Route path="/labs/merchant-center-test" element={<MerchantCenterTest />} />
                        <Route path="/labs/live-today" element={<LiveToday />} />
                        <Route path="/labs/search-console" element={<SearchConsoleLab />} />
                        <Route path="/labs/shopify" element={<ShopifyLab />} />
                        <Route path="/labs/poc-showcase" element={<PoCShowcase />} />
                        <Route path="/labs/sendgrid-test" element={<SendgridTest />} />
                        <Route path="/labs/gbp-test" element={<GBPTest />} />
                        <Route path="/labs/woocommerce-test" element={<WooCommerceLab />} />
                        <Route path="/meta/meta-audiences" element={<MetaAudiencesLab />} />
                        <Route path="/lab/search-volume-bulk" element={<SearchVolumeBulk />} />
                        <Route path="/lab/keyword-discover-bulk" element={<KeywordDiscoverBulk />} />
                        <Route path="/labs/search-campaign-wizard" element={<SearchCampaignWizard />} />
                        <Route path="/lab/instagram-radar" element={<InstagramRadar />} />
                        <Route path="/lab/instagram-search" element={<InstagramSearchLab />} />
                        <Route path="/lab/high5-keywords" element={<High5KeywordResearch />} />
                        <Route path="/reports/high5-boomsonar" element={<High5KeywordResearch />} />
                        <Route path="/lab/facebook-ads-library-rapid" element={<FacebookAdsLibraryRapidLab />} />
                        <Route path="/lab/google-ads-transparency-rapid" element={<GoogleAdsTransparencyRapidLab />} />
                        <Route path="/labs/ikas" element={<IkasApiLab />} />
                        <Route path="/labs/tsoft-sales" element={<TsoftSalesLab />} />
                        <Route path="/labs/site-meta-crawler" element={<SiteMetaCrawlerLab />} />
                        <Route path="/labs/google-ads-youtube" element={<YouTubeCampaignsLab />} />
                        <Route path="/ikas/overview" element={<IkasOverview />} />
        <Route path="/shopify/overview" element={<ShopifyOverview />} />
        <Route path="/shopify/product-performance" element={<ShopifyProductPerformance />} />
        <Route path="/shopify/custom-segments" element={<ShopifyCustomerSegments />} />
        <Route path="/shopify/buying-segment" element={<ShopifyCustomerPurchaseSegments />} />
        <Route path="/shopify/category-segments" element={<ShopifyCustomerCategorySegments />} />
        <Route path="/shopify/product-customer-segments" element={<ShopifyProductCustomerSegments />} />
        <Route path="/shopify/loyalty" element={<ShopifyLoyalty />} />
                        <Route path="/ikas/product-performance" element={<IkasProductPerformance />} />
                        <Route path="/ikas/custom-segments" element={<IkasCustomSegments />} />
                        <Route path="/ikas/buying-segment" element={<IkasBuyingSegment />} />
                        <Route path="/ikas/category-segments" element={<IkasCustomerCategorySegments />} />
                        <Route path="/ikas/product-customer-segments" element={<IkasProductCustomerSegments />} />
                        <Route path="/ikas/loyalty" element={<IkasLoyalty />} />
                        <Route path="/ikas/sandbox" element={<IkasSandbox />} />
                        <Route path="/ikas/stock" element={<IkasStockByBrand />} />
                        <Route path="/ikas/inventory" element={<IkasInventory />} />
                        <Route path="/ikas/stock-coverage" element={<IkasStockCoverage />} />
                        <Route path="/shopify/stock-coverage" element={<IkasStockCoverage source="shopify" />} />
                        <Route path="/ikas/monthly-fetch" element={<IkasMonthlyFetch />} />
                        <Route path="/woocommerce/overview" element={<WooOverview />} />
                        <Route path="/woocommerce/product-performance" element={<WooProductPerformance />} />
                        <Route path="/woocommerce/custom-segments" element={<WooCustomSegments />} />
                        <Route path="/woocommerce/buying-segment" element={<WooBuyingSegment />} />
                        <Route path="/woocommerce/category-segments" element={<WooCustomerCategorySegments />} />
                        <Route path="/woocommerce/product-customer-segments" element={<WooProductCustomerSegments />} />
                        <Route path="/woocommerce/loyalty" element={<WooLoyalty />} />
                        <Route path="/adjust/overview" element={<AdjustOverview />} />
                        <Route path="/adjust/traffic-acquisition" element={<AdjustTraffic />} />
                        <Route path="/merchant-center/performance" element={<MerchantCenterPerformance />} />
                        <Route path="/merchant-center/price-benchmark" element={<MerchantCenterPriceBenchmark />} />
                        <Route path="/merchant-center/inventory" element={<MerchantCenterInventory />} />
                        <Route path="/merchant-center/inventory-performance" element={<MerchantCenterInventoryPerformance />} />
                        <Route path="/merchant-center/variant-performance" element={<MerchantCenterVariantPerformance />} />
                        <Route path="/merchant-center/custom-labels" element={<MerchantCenterCustomLabels />} />
                        <Route path="/merchant-center/discount-tracking" element={<MerchantCenterDiscountTracker />} />
                        <Route path="/market-insights/campaign-calendar" element={<CampaignCalendar />} />
                        <Route path="/labs/gemini" element={<GeminiPlayground />} />
                        <Route path="/labs/image-editor" element={<ImageEditor />} />
                        <Route path="/labs/image-enhance" element={<ImageEnhance />} />
                        <Route path="/labs/image-equalize" element={<ImageEqualize />} />
                        <Route path="/labs/png-background" element={<PngBackgroundFitter />} />
                        <Route path="/labs/platform-resizer" element={<PlatformResizer />} />
                        <Route path="/labs/pastperfect-studio" element={
                          <ProtectedRoute requireBrand={false} allowEmails={['efe@glowytics.com', 'efe@heyglowy.com', 'defne@pastperfect.co']}>
                            <PastPerfectStudio />
                          </ProtectedRoute>
                        } />
                        <Route path="/labs/product-concept" element={<ProductConcept />} />
                        <Route path="/labs/joyico-studio" element={<JoyicoStudio />} />
                        <Route path="/labs/inviter-ads" element={<InviterAds />} />
                        <Route path="/labs/bq-channel-performance" element={<BqChannelPerformanceTest />} />
                        <Route path="/labs/megapixel-fit" element={<MegapixelFit />} />
                        <Route path="/ads-content" element={<AdsLibraryExport />} />
                        <Route path="/meta-static-assets" element={<MetaStaticAssets />} />
                        <Route path="/budget-overview" element={<BudgetOverview />} />
                        <Route path="/labs/deep-research" element={<DeepResearchPlayground />} />
                        <Route path="/labs/maps-grounding" element={<MapsGroundingPlayground />} />
                        <Route path="/market-insights/place-reviews" element={<PlaceReviews />} />
                        <Route path="/xml-feed-analyzer" element={<XmlFeedAnalyzer />} />
                        
                        {/* BigQuery Explorer */}
                        <Route path="/bigquery-explorer" element={<BigQueryExplorer />} />
                        <Route path="/analytics/bq-dashboard" element={<BQAnalyticsDashboard />} />
                        <Route path="/analytics/bq-traffic-daily" element={<BQTrafficSourcesDaily />} />
                        <Route path="/analytics/bq-item-sales" element={<BQItemSalesReport />} />
                        <Route path="/meta/billing" element={<MetaBilling />} />

                        {/* My Account Route */}
                        <Route path="/my-account" element={<MyAccount />} />
                        {/* Superuser-only route (does not require brand) */}
                        <Route path="/hq/admin/smart-campaigns" element={
                          <ProtectedRoute requireBrand={false} allowUserIds={["95bf7597-bb83-4f50-9bdb-8678a86e1084", "2f30b2c9-08fc-40dc-9414-63628c580ae8"]}>
                            <AdminSmartCampaigns />
                          </ProtectedRoute>
                        } />
                        <Route path="/hq/admin/smart-campaigns/:brandId/:configId" element={
                          <ProtectedRoute requireBrand={false} allowUserIds={["95bf7597-bb83-4f50-9bdb-8678a86e1084", "2f30b2c9-08fc-40dc-9414-63628c580ae8"]}>
                            <SmartCampaignDetail />
                          </ProtectedRoute>
                        } />
                        <Route path="/hq/admin/mc-disapproval-monitor" element={
                          <ProtectedRoute requireBrand={false} allowUserIds={["95bf7597-bb83-4f50-9bdb-8678a86e1084"]}>
                            <AdminMcDisapprovalMonitor />
                          </ProtectedRoute>
                        } />
                        <Route path="/hq/admin/google-ads-clone" element={
                          <ProtectedRoute requireBrand={true}>
                            <AdminGoogleAdsClone />
                          </ProtectedRoute>
                        } />
                        <Route path="/hq/admin" element={
                          <ProtectedRoute requireBrand={false} allowUserIds={["95bf7597-bb83-4f50-9bdb-8678a86e1084"]}>
                            <AdminPanel />
                          </ProtectedRoute>
                        } />
                        {/* Aranma Hacmi Bülteni — internal, sidebar'da yok (email allowlist).
                            Marka gerekir: kelimeler marka şemasından geliyor. */}
                        <Route path="/internal/search-volume-digest" element={
                          <ProtectedRoute allowEmails={["efe@glowytics.com", "efe@heyglowy.com"]}>
                            <SearchVolumeDigest />
                          </ProtectedRoute>
                        } />
                        {/* Proje Mezarlığı — sadece sahibine açık (email allowlist) */}
                        <Route path="/hq/backlog" element={
                          <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com"]}>
                            <ProjectBacklog />
                          </ProtectedRoute>
                        } />
                        {/* Google Business Profile yönetimi — iç kullanım (email allowlist).
                            Backend /api/gbp da aynı listeyle kilitli — çift kilit. */}
                        <Route path="/hq/gbp" element={
                          <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com"]}>
                            <GbpHq />
                          </ProtectedRoute>
                        } />
                        {/* Web Summit brief — statik one-pager, sadece sahibine açık */}
                        <Route path="/hq/websummit" element={
                          <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com"]}>
                            <WebSummitBrief />
                          </ProtectedRoute>
                        } />
                        {/* Value Story anlatı akışı — statik board, sadece sahibine açık */}
                        <Route path="/hq/narrative-flow" element={
                          <ProtectedRoute requireBrand={false} allowEmails={["efe@heyglowy.com", "efe@glowytics.com"]}>
                            <NarrativeFlow />
                          </ProtectedRoute>
                        } />
                        {/* Pixel Analytics */}
                        {/* GBP lokasyonları — marka bazlı, çok kiracılı.
                            Asıl yetki kontrolü backend'de (/api/gbp-brand). */}
                        <Route path="/gbp/locations" element={
                          <ProtectedRoute>
                            <GbpLocations />
                          </ProtectedRoute>
                        } />
                        <Route path="/pixel-analytics" element={
                          <ProtectedRoute>
                            <PixelAnalytics />
                          </ProtectedRoute>
                        } />
                        
                        {/* Settings Route */}
                        <Route path="/settings" element={<SettingsRouteGuard><Settings /></SettingsRouteGuard>} />
                        {/* Live Snippet (brand-scoped) */}
                        <Route path="/live-snippet" element={<LiveSnippet />} />

                        {/* Data Sync Logs Route */}
                        <Route path="/brands/:brandId/data-sync-logs" element={<DataSyncLogs />} />

                        {/* Data Health - redirects to Settings section */}
                        <Route path="/data-health" element={<Navigate to="/settings?section=data-health" replace />} />

                        {/* AI Chat Route */}
                        <Route path="/ai-chat" element={<AIChat />} />
                        <Route path="/glowy-ai" element={<ChatbotV2 />} />
                        <Route path="/chatbotv2" element={<Navigate to="/glowy-ai" replace />} />
                        <Route path="/glowyai-marketing-assistant" element={<Glowyaigamini />} />

                        {/* Hourly Performance Route */}
                        <Route path="/hourly-performance" element={<HourlyPerformance />} />

                        {/* Creative Builder Route */}
                        <Route path="/creative-builder" element={<CreativeBuilder />} />

                        {/* Ads Builder Route */}
                        <Route path="/ads-builder" element={<AdsBuilder />} />

                        {/* Momentum Builder Route */}
                        <Route path="/momentum-builder" element={<MomentumBuilder />} />

                        {/* Sixt Store Branch Performance Route */}
                        <Route path="/sixt-store-branch-performance" element={<SixtStoreBranchPerformance />} />
                        <Route path="/high5/funnel-performance" element={<High5FunnelPerformance />} />
                        <Route path="/sixt-location-pricing" element={<SixtLocationPricing />} />
                        <Route path="/sixt-vehicle-performance" element={<SixtVehiclePerformance />} />

                        {/* Market Share Route */}
                        <Route path="/competitors/market-share" element={<MarketShareDashboard />} />

                        {/* Share of Voice Route */}
                        <Route path="/competitors/share-of-voice" element={<ShareOfVoiceDashboard />} />
                      </Routes>
                  </AppShell>
                </ProtectedRoute>
              }
            />
          </Routes>
        </AccountProvider>
        </BrandProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
